var items = {
  "block.minecraft.acacia_button": "Cnaipe Acáise",
  "block.minecraft.acacia_door": "Doras Acáise",
  "block.minecraft.acacia_fence": "Claí Acáise",
  "block.minecraft.acacia_fence_gate": "Geata Acáise",
  "block.minecraft.acacia_hanging_sign": "Comhartha Crochta Acáise",
  "block.minecraft.acacia_leaves": "Duilleoga Acáise",
  "block.minecraft.acacia_log": "Bloc Acáise",
  "block.minecraft.acacia_planks": "Cláir Acáise",
  "block.minecraft.acacia_pressure_plate": "Brúphláta Acáise",
  "block.minecraft.acacia_sapling": "Buinneán Acáise",
  "block.minecraft.acacia_shelf": "Seilf Acáise",
  "block.minecraft.acacia_sign": "Comhartha Acáise",
  "block.minecraft.acacia_slab": "Leac Acáise",
  "block.minecraft.acacia_stairs": "Staighre Acáise",
  "block.minecraft.acacia_trapdoor": "Comhla Acáise",
  "block.minecraft.acacia_wall_hanging_sign": "Comhartha Crochta Balla Acáise",
  "block.minecraft.acacia_wall_sign": "Comhartha Balla Acáise",
  "block.minecraft.acacia_wood": "Adhmad Acáise",
  "block.minecraft.activator_rail": "Ráille Gníomhachtóra",
  "block.minecraft.air": "Aer",
  "block.minecraft.allium": "Allium",
  "block.minecraft.amethyst_block": "Bloc Aimitise",
  "block.minecraft.amethyst_cluster": "Triopall Aimitise",
  "block.minecraft.ancient_debris": "Mionbhach Ársa",
  "block.minecraft.andesite": "Aindéisít",
  "block.minecraft.andesite_slab": "Leac Aindéisíte",
  "block.minecraft.andesite_stairs": "Staighre Aindéisíte",
  "block.minecraft.andesite_wall": "Balla Aindéisíte",
  "block.minecraft.anvil": "Inneoin",
  "block.minecraft.attached_melon_stem": "Gas Mealbhacáin Nasctha",
  "block.minecraft.attached_pumpkin_stem": "Gas Puimcín Nasctha",
  "block.minecraft.azalea": "Asáilia",
  "block.minecraft.azalea_leaves": "Duilleoga Asáilia",
  "block.minecraft.azure_bluet": "Goirmín Spéiriúil",
  "block.minecraft.bamboo": "Bambú",
  "block.minecraft.bamboo_block": "Bloc Bambú",
  "block.minecraft.bamboo_button": "Cnaipe Bambú",
  "block.minecraft.bamboo_door": "Doras Bambú",
  "block.minecraft.bamboo_fence": "Claí Bambú",
  "block.minecraft.bamboo_fence_gate": "Geata Bambú",
  "block.minecraft.bamboo_hanging_sign": "Comhartha Crochta Bambú",
  "block.minecraft.bamboo_mosaic": "Mósáic Bhambú",
  "block.minecraft.bamboo_mosaic_slab": "Leac Mósáice Bambú",
  "block.minecraft.bamboo_mosaic_stairs": "Staighre Mósáice Bambú",
  "block.minecraft.bamboo_planks": "Cláir Bhambú",
  "block.minecraft.bamboo_pressure_plate": "Brúphláta Bambú",
  "block.minecraft.bamboo_sapling": "Buinneán Bambú",
  "block.minecraft.bamboo_shelf": "Seilf Bhambú",
  "block.minecraft.bamboo_sign": "Comhartha Bambú",
  "block.minecraft.bamboo_slab": "Leac Bhambú",
  "block.minecraft.bamboo_stairs": "Staighre Bambú",
  "block.minecraft.bamboo_trapdoor": "Comhla Bhambú",
  "block.minecraft.bamboo_wall_hanging_sign": "Comhartha Crochta Balla Bambú",
  "block.minecraft.bamboo_wall_sign": "Comhartha Balla Bambú",
  "block.minecraft.banner.base.black": "Machaire Dubh",
  "block.minecraft.banner.base.blue": "Machaire Gorm",
  "block.minecraft.banner.base.brown": "Machaire Donn",
  "block.minecraft.banner.base.cyan": "Machaire Cian",
  "block.minecraft.banner.base.gray": "Machaire Liath",
  "block.minecraft.banner.base.green": "Machaire Uaine",
  "block.minecraft.banner.base.light_blue": "Machaire Bánghorm",
  "block.minecraft.banner.base.light_gray": "Machaire Fionnliath",
  "block.minecraft.banner.base.lime": "Machaire Glasuaine",
  "block.minecraft.banner.base.magenta": "Machaire Maigeanta",
  "block.minecraft.banner.base.orange": "Machaire Oráiste",
  "block.minecraft.banner.base.pink": "Machaire Bándearg",
  "block.minecraft.banner.base.purple": "Machaire Corcra",
  "block.minecraft.banner.base.red": "Machaire Dearg",
  "block.minecraft.banner.base.white": "Machaire Bán",
  "block.minecraft.banner.base.yellow": "Machaire Buí",
  "block.minecraft.banner.border.black": "Imeallbhord Dubh",
  "block.minecraft.banner.border.blue": "Imeallbhord Gorm",
  "block.minecraft.banner.border.brown": "Imeallbhord Donn",
  "block.minecraft.banner.border.cyan": "Imeallbhord Cian",
  "block.minecraft.banner.border.gray": "Imeallbhord Liath",
  "block.minecraft.banner.border.green": "Imeallbhord Uaine",
  "block.minecraft.banner.border.light_blue": "Imeallbhord Bánghorm",
  "block.minecraft.banner.border.light_gray": "Imeallbhord Fionnliath",
  "block.minecraft.banner.border.lime": "Imeallbhord Glasuaine",
  "block.minecraft.banner.border.magenta": "Imeallbhord Maigeanta",
  "block.minecraft.banner.border.orange": "Imeallbhord Oráiste",
  "block.minecraft.banner.border.pink": "Imeallbhord Bándearg",
  "block.minecraft.banner.border.purple": "Imeallbhord Corcra",
  "block.minecraft.banner.border.red": "Imeallbhord Dearg",
  "block.minecraft.banner.border.white": "Imeallbhord Bán",
  "block.minecraft.banner.border.yellow": "Imeallbhord Buí",
  "block.minecraft.banner.bricks.black": "Machaire Saoirsithe Dubh",
  "block.minecraft.banner.bricks.blue": "Machaire Saoirsithe Gorm",
  "block.minecraft.banner.bricks.brown": "Machaire Saoirsithe Donn",
  "block.minecraft.banner.bricks.cyan": "Machaire Saoirsithe Cian",
  "block.minecraft.banner.bricks.gray": "Machaire Saoirsithe Liath",
  "block.minecraft.banner.bricks.green": "Machaire Saoirsithe Uaine",
  "block.minecraft.banner.bricks.light_blue": "Machaire Saoirsithe Bánghorm",
  "block.minecraft.banner.bricks.light_gray": "Machaire Saoirsithe Fionnliath",
  "block.minecraft.banner.bricks.lime": "Machaire Saoirsithe Glasuaine",
  "block.minecraft.banner.bricks.magenta": "Machaire Saoirsithe Maigeanta",
  "block.minecraft.banner.bricks.orange": "Machaire Saoirsithe Oráiste",
  "block.minecraft.banner.bricks.pink": "Machaire Saoirsithe Bándearg",
  "block.minecraft.banner.bricks.purple": "Machaire Saoirsithe Corcra",
  "block.minecraft.banner.bricks.red": "Machaire Saoirsithe Dearg",
  "block.minecraft.banner.bricks.white": "Machaire Saoirsithe Bán",
  "block.minecraft.banner.bricks.yellow": "Machaire Saoirsithe Buí",
  "block.minecraft.banner.circle.black": "Cruinneán Dubh",
  "block.minecraft.banner.circle.blue": "Cruinneán Gorm",
  "block.minecraft.banner.circle.brown": "Cruinneán Donn",
  "block.minecraft.banner.circle.cyan": "Cruinneán Cian",
  "block.minecraft.banner.circle.gray": "Cruinneán Liath",
  "block.minecraft.banner.circle.green": "Cruinneán Uaine",
  "block.minecraft.banner.circle.light_blue": "Cruinneán Bánghorm",
  "block.minecraft.banner.circle.light_gray": "Cruinneán Fionnliath",
  "block.minecraft.banner.circle.lime": "Cruinneán Glasuaine",
  "block.minecraft.banner.circle.magenta": "Cruinneán Maigeanta",
  "block.minecraft.banner.circle.orange": "Cruinneán Oráiste",
  "block.minecraft.banner.circle.pink": "Cruinneán Bándearg",
  "block.minecraft.banner.circle.purple": "Cruinneán Corcra",
  "block.minecraft.banner.circle.red": "Cruinneán Dearg",
  "block.minecraft.banner.circle.white": "Cruinneán Bán",
  "block.minecraft.banner.circle.yellow": "Cruinneán Buí",
  "block.minecraft.banner.creeper.black": "Fíor Creeper Dubh",
  "block.minecraft.banner.creeper.blue": "Fíor Creeper Gorm",
  "block.minecraft.banner.creeper.brown": "Fíor Creeper Donn",
  "block.minecraft.banner.creeper.cyan": "Fíor Creeper Cian",
  "block.minecraft.banner.creeper.gray": "Fíor Creeper Liath",
  "block.minecraft.banner.creeper.green": "Fíor Creeper Uaine",
  "block.minecraft.banner.creeper.light_blue": "Fíor Creeper Bánghorm",
  "block.minecraft.banner.creeper.light_gray": "Fíor Creeper Fionnliath",
  "block.minecraft.banner.creeper.lime": "Fíor Creeper Glasuaine",
  "block.minecraft.banner.creeper.magenta": "Fíor Creeper Maigeanta",
  "block.minecraft.banner.creeper.orange": "Fíor Creeper Oráiste",
  "block.minecraft.banner.creeper.pink": "Fíor Creeper Bándearg",
  "block.minecraft.banner.creeper.purple": "Fíor Creeper Corcra",
  "block.minecraft.banner.creeper.red": "Fíor Creeper Dearg",
  "block.minecraft.banner.creeper.white": "Fíor Creeper Bán",
  "block.minecraft.banner.creeper.yellow": "Fíor Creeper Buí",
  "block.minecraft.banner.cross.black": "Sailtír Dhubh",
  "block.minecraft.banner.cross.blue": "Sailtír Ghorm",
  "block.minecraft.banner.cross.brown": "Sailtír Dhonn",
  "block.minecraft.banner.cross.cyan": "Sailtír Chian",
  "block.minecraft.banner.cross.gray": "Sailtír Liath",
  "block.minecraft.banner.cross.green": "Sailtír Uaine",
  "block.minecraft.banner.cross.light_blue": "Sailtír Bhánghorm",
  "block.minecraft.banner.cross.light_gray": "Sailtír Fhionnliath",
  "block.minecraft.banner.cross.lime": "Sailtír Ghlasuaine",
  "block.minecraft.banner.cross.magenta": "Sailtír Mhaigeanta",
  "block.minecraft.banner.cross.orange": "Sailtír Oráiste",
  "block.minecraft.banner.cross.pink": "Sailtír Bhándearg",
  "block.minecraft.banner.cross.purple": "Sailtír Chorcra",
  "block.minecraft.banner.cross.red": "Sailtír Dhearg",
  "block.minecraft.banner.cross.white": "Sailtír Bhán",
  "block.minecraft.banner.cross.yellow": "Sailtír Bhuí",
  "block.minecraft.banner.curly_border.black": "Imeallbhord Eangach Dubh",
  "block.minecraft.banner.curly_border.blue": "Imeallbhord Eangach Gorm",
  "block.minecraft.banner.curly_border.brown": "Imeallbhord Eangach Donn",
  "block.minecraft.banner.curly_border.cyan": "Imeallbhord Eangach Cian",
  "block.minecraft.banner.curly_border.gray": "Imeallbhord Eangach Liath",
  "block.minecraft.banner.curly_border.green": "Imeallbhord Eangach Uaine",
  "block.minecraft.banner.curly_border.light_blue": "Imeallbhord Eangach Bánghorm",
  "block.minecraft.banner.curly_border.light_gray": "Imeallbhord Eangach Fionnliath",
  "block.minecraft.banner.curly_border.lime": "Imeallbhord Eangach Glasuaine",
  "block.minecraft.banner.curly_border.magenta": "Imeallbhord Eangach Maigeanta",
  "block.minecraft.banner.curly_border.orange": "Imeallbhord Eangach Oráiste",
  "block.minecraft.banner.curly_border.pink": "Imeallbhord Eangach Bándearg",
  "block.minecraft.banner.curly_border.purple": "Imeallbhord Eangach Corcra",
  "block.minecraft.banner.curly_border.red": "Imeallbhord Eangach Dearg",
  "block.minecraft.banner.curly_border.white": "Imeallbhord Eangach Bán",
  "block.minecraft.banner.curly_border.yellow": "Imeallbhord Eangach Buí",
  "block.minecraft.banner.diagonal_left.black": "Cléroinnte Dubh",
  "block.minecraft.banner.diagonal_left.blue": "Cléroinnte Gorm",
  "block.minecraft.banner.diagonal_left.brown": "Cléroinnte Donn",
  "block.minecraft.banner.diagonal_left.cyan": "Cléroinnte Cian",
  "block.minecraft.banner.diagonal_left.gray": "Cléroinnte Liath",
  "block.minecraft.banner.diagonal_left.green": "Cléroinnte Uaine",
  "block.minecraft.banner.diagonal_left.light_blue": "Cléroinnte Bánghorm",
  "block.minecraft.banner.diagonal_left.light_gray": "Cléroinnte Fionnliath",
  "block.minecraft.banner.diagonal_left.lime": "Cléroinnte Glasuaine",
  "block.minecraft.banner.diagonal_left.magenta": "Cléroinnte Maigeanta",
  "block.minecraft.banner.diagonal_left.orange": "Cléroinnte Oráiste",
  "block.minecraft.banner.diagonal_left.pink": "Cléroinnte Bándearg",
  "block.minecraft.banner.diagonal_left.purple": "Cléroinnte Corcra",
  "block.minecraft.banner.diagonal_left.red": "Cléroinnte Dearg",
  "block.minecraft.banner.diagonal_left.white": "Cléroinnte Bán",
  "block.minecraft.banner.diagonal_left.yellow": "Cléroinnte Buí",
  "block.minecraft.banner.diagonal_right.black": "Criosroinnte Dubh",
  "block.minecraft.banner.diagonal_right.blue": "Criosroinnte Gorm",
  "block.minecraft.banner.diagonal_right.brown": "Criosroinnte Donn",
  "block.minecraft.banner.diagonal_right.cyan": "Criosroinnte Cian",
  "block.minecraft.banner.diagonal_right.gray": "Criosroinnte Liath",
  "block.minecraft.banner.diagonal_right.green": "Criosroinnte Uaine",
  "block.minecraft.banner.diagonal_right.light_blue": "Criosroinnte Bánghorm",
  "block.minecraft.banner.diagonal_right.light_gray": "Criosroinnte Fionnliath",
  "block.minecraft.banner.diagonal_right.lime": "Criosroinnte Glasuaine",
  "block.minecraft.banner.diagonal_right.magenta": "Criosroinnte Maigeanta",
  "block.minecraft.banner.diagonal_right.orange": "Criosroinnte Oráiste",
  "block.minecraft.banner.diagonal_right.pink": "Criosroinnte Bándearg",
  "block.minecraft.banner.diagonal_right.purple": "Criosroinnte Corcra",
  "block.minecraft.banner.diagonal_right.red": "Criosroinnte Dearg",
  "block.minecraft.banner.diagonal_right.white": "Criosroinnte Bán",
  "block.minecraft.banner.diagonal_right.yellow": "Criosroinnte Buí",
  "block.minecraft.banner.diagonal_up_left.black": "Criosroinnte Bunoscionn Dubh",
  "block.minecraft.banner.diagonal_up_left.blue": "Criosroinnte Bunoscionn Gorm",
  "block.minecraft.banner.diagonal_up_left.brown": "Criosroinnte Bunoscionn Donn",
  "block.minecraft.banner.diagonal_up_left.cyan": "Criosroinnte Bunoscionn Cian",
  "block.minecraft.banner.diagonal_up_left.gray": "Criosroinnte Bunoscionn Liath",
  "block.minecraft.banner.diagonal_up_left.green": "Criosroinnte Bunoscionn Uaine",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Criosroinnte Bunoscionn Bánghorm",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Criosroinnte Bunoscionn Fionnliath",
  "block.minecraft.banner.diagonal_up_left.lime": "Criosroinnte Bunoscionn Glasuaine",
  "block.minecraft.banner.diagonal_up_left.magenta": "Criosroinnte Bunoscionn Maigeanta",
  "block.minecraft.banner.diagonal_up_left.orange": "Criosroinnte Bunoscionn Oráiste",
  "block.minecraft.banner.diagonal_up_left.pink": "Criosroinnte Bunoscionn Bándearg",
  "block.minecraft.banner.diagonal_up_left.purple": "Criosroinnte Bunoscionn Corcra",
  "block.minecraft.banner.diagonal_up_left.red": "Criosroinnte Bunoscionn Dearg",
  "block.minecraft.banner.diagonal_up_left.white": "Criosroinnte Bunoscionn Bán",
  "block.minecraft.banner.diagonal_up_left.yellow": "Criosroinnte Bunoscionn Buí",
  "block.minecraft.banner.diagonal_up_right.black": "Cléroinnte Bunoscionn Dubh",
  "block.minecraft.banner.diagonal_up_right.blue": "Cléroinnte Bunoscionn Gorm",
  "block.minecraft.banner.diagonal_up_right.brown": "Cléroinnte Bunoscionn Donn",
  "block.minecraft.banner.diagonal_up_right.cyan": "Cléroinnte Bunoscionn Cian",
  "block.minecraft.banner.diagonal_up_right.gray": "Cléroinnte Bunoscionn Liath",
  "block.minecraft.banner.diagonal_up_right.green": "Cléroinnte Bunoscionn Uaine",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Cléroinnte Bunoscionn Bánghorm",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Cléroinnte Bunoscionn Fionnliath",
  "block.minecraft.banner.diagonal_up_right.lime": "Cléroinnte Bunoscionn Glasuaine",
  "block.minecraft.banner.diagonal_up_right.magenta": "Cléroinnte Bunoscionn Maigeanta",
  "block.minecraft.banner.diagonal_up_right.orange": "Cléroinnte Bunoscionn Oráiste",
  "block.minecraft.banner.diagonal_up_right.pink": "Cléroinnte Bunoscionn Bándearg",
  "block.minecraft.banner.diagonal_up_right.purple": "Cléroinnte Bunoscionn Corcra",
  "block.minecraft.banner.diagonal_up_right.red": "Cléroinnte Bunoscionn Dearg",
  "block.minecraft.banner.diagonal_up_right.white": "Cléroinnte Bunoscionn Bán",
  "block.minecraft.banner.diagonal_up_right.yellow": "Cléroinnte Bunoscionn Buí",
  "block.minecraft.banner.flow.black": "Bís Dhubh",
  "block.minecraft.banner.flow.blue": "Bís Ghorm",
  "block.minecraft.banner.flow.brown": "Bís Dhonn",
  "block.minecraft.banner.flow.cyan": "Bís Chian",
  "block.minecraft.banner.flow.gray": "Bís Liath",
  "block.minecraft.banner.flow.green": "Bís Uaine",
  "block.minecraft.banner.flow.light_blue": "Bís Bhánghorm",
  "block.minecraft.banner.flow.light_gray": "Bís Fhionnliath",
  "block.minecraft.banner.flow.lime": "Bís Ghlasuaine",
  "block.minecraft.banner.flow.magenta": "Bís Mhaigeanta",
  "block.minecraft.banner.flow.orange": "Bís Oráiste",
  "block.minecraft.banner.flow.pink": "Bís Bhándearg",
  "block.minecraft.banner.flow.purple": "Bís Chorcra",
  "block.minecraft.banner.flow.red": "Bís Dhearg",
  "block.minecraft.banner.flow.white": "Bís Bhán",
  "block.minecraft.banner.flow.yellow": "Bís Bhuí",
  "block.minecraft.banner.flower.black": "Fíor Blátha Dubh",
  "block.minecraft.banner.flower.blue": "Fíor Blátha Gorm",
  "block.minecraft.banner.flower.brown": "Fíor Blátha Donn",
  "block.minecraft.banner.flower.cyan": "Fíor Blátha Cian",
  "block.minecraft.banner.flower.gray": "Fíor Blátha Liath",
  "block.minecraft.banner.flower.green": "Fíor Blátha Uaine",
  "block.minecraft.banner.flower.light_blue": "Fíor Blátha Bánghorm",
  "block.minecraft.banner.flower.light_gray": "Fíor Blátha Fionnliath",
  "block.minecraft.banner.flower.lime": "Fíor Blátha Glasuaine",
  "block.minecraft.banner.flower.magenta": "Fíor Blátha Maigeanta",
  "block.minecraft.banner.flower.orange": "Fíor Blátha Oráiste",
  "block.minecraft.banner.flower.pink": "Fíor Blátha Bándearg",
  "block.minecraft.banner.flower.purple": "Fíor Blátha Corcra",
  "block.minecraft.banner.flower.red": "Fíor Blátha Dearg",
  "block.minecraft.banner.flower.white": "Fíor Blátha Bán",
  "block.minecraft.banner.flower.yellow": "Fíor Blátha Buí",
  "block.minecraft.banner.globe.black": "Cruinneog Dhubh",
  "block.minecraft.banner.globe.blue": "Cruinneog Ghorm",
  "block.minecraft.banner.globe.brown": "Cruinneog Dhonn",
  "block.minecraft.banner.globe.cyan": "Cruinneog Chian",
  "block.minecraft.banner.globe.gray": "Cruinneog Liath",
  "block.minecraft.banner.globe.green": "Cruinneog Uaine",
  "block.minecraft.banner.globe.light_blue": "Cruinneog Bhánghorm",
  "block.minecraft.banner.globe.light_gray": "Cruinneog Fhionnliath",
  "block.minecraft.banner.globe.lime": "Cruinneog Ghlasuaine",
  "block.minecraft.banner.globe.magenta": "Cruinneog Mhaigeanta",
  "block.minecraft.banner.globe.orange": "Cruinneog Oráiste",
  "block.minecraft.banner.globe.pink": "Cruinneog Bhándearg",
  "block.minecraft.banner.globe.purple": "Cruinneog Chorcra",
  "block.minecraft.banner.globe.red": "Cruinneog Dhearg",
  "block.minecraft.banner.globe.white": "Cruinneog Bhán",
  "block.minecraft.banner.globe.yellow": "Cruinneog Bhuí",
  "block.minecraft.banner.gradient.black": "Grádán Dubh",
  "block.minecraft.banner.gradient.blue": "Grádán Gorm",
  "block.minecraft.banner.gradient.brown": "Grádán Donn",
  "block.minecraft.banner.gradient.cyan": "Grádán Cian",
  "block.minecraft.banner.gradient.gray": "Grádán Liath",
  "block.minecraft.banner.gradient.green": "Grádán Uaine",
  "block.minecraft.banner.gradient.light_blue": "Grádán Bánghorm",
  "block.minecraft.banner.gradient.light_gray": "Grádán Fionnliath",
  "block.minecraft.banner.gradient.lime": "Grádán Glasuaine",
  "block.minecraft.banner.gradient.magenta": "Grádán Maigeanta",
  "block.minecraft.banner.gradient.orange": "Grádán Oráiste",
  "block.minecraft.banner.gradient.pink": "Grádán Bándearg",
  "block.minecraft.banner.gradient.purple": "Grádán Corcra",
  "block.minecraft.banner.gradient.red": "Grádán Dearg",
  "block.minecraft.banner.gradient.white": "Grádán Bán",
  "block.minecraft.banner.gradient.yellow": "Grádán Buí",
  "block.minecraft.banner.gradient_up.black": "Grádán Dubh ó Bhun",
  "block.minecraft.banner.gradient_up.blue": "Grádán Gorm ó Bhun",
  "block.minecraft.banner.gradient_up.brown": "Grádán Donn ó Bhun",
  "block.minecraft.banner.gradient_up.cyan": "Grádán Cian ó Bhun",
  "block.minecraft.banner.gradient_up.gray": "Grádán Liath ó Bhun",
  "block.minecraft.banner.gradient_up.green": "Grádán Uaine ó Bhun",
  "block.minecraft.banner.gradient_up.light_blue": "Grádán Bánghorm ó Bhun",
  "block.minecraft.banner.gradient_up.light_gray": "Grádán Fionnliath ó Bhun",
  "block.minecraft.banner.gradient_up.lime": "Grádán Glasuaine ó Bhun",
  "block.minecraft.banner.gradient_up.magenta": "Grádán Maigeanta ó Bhun",
  "block.minecraft.banner.gradient_up.orange": "Grádán Oráiste ó Bhun",
  "block.minecraft.banner.gradient_up.pink": "Grádán Bándearg ó Bhun",
  "block.minecraft.banner.gradient_up.purple": "Grádán Corcra ó Bhun",
  "block.minecraft.banner.gradient_up.red": "Grádán Dearg ó Bhun",
  "block.minecraft.banner.gradient_up.white": "Grádán Bán ó Bhun",
  "block.minecraft.banner.gradient_up.yellow": "Grádán Buí ó Bhun",
  "block.minecraft.banner.guster.black": "Fíor Gaotháin Dubh",
  "block.minecraft.banner.guster.blue": "Fíor Gaotháin Gorm",
  "block.minecraft.banner.guster.brown": "Fíor Gaotháin Donn",
  "block.minecraft.banner.guster.cyan": "Fíor Gaotháin Cian",
  "block.minecraft.banner.guster.gray": "Fíor Gaotháin Liath",
  "block.minecraft.banner.guster.green": "Fíor Gaotháin Uaine",
  "block.minecraft.banner.guster.light_blue": "Fíor Gaotháin Bánghorm",
  "block.minecraft.banner.guster.light_gray": "Fíor Gaotháin Fionnliath",
  "block.minecraft.banner.guster.lime": "Fíor Gaotháin Glasuaine",
  "block.minecraft.banner.guster.magenta": "Fíor Gaotháin Maigeanta",
  "block.minecraft.banner.guster.orange": "Fíor Gaotháin Oráiste",
  "block.minecraft.banner.guster.pink": "Fíor Gaotháin Bándearg",
  "block.minecraft.banner.guster.purple": "Fíor Gaotháin Corcra",
  "block.minecraft.banner.guster.red": "Fíor Gaotháin Dearg",
  "block.minecraft.banner.guster.white": "Fíor Gaotháin Bán",
  "block.minecraft.banner.guster.yellow": "Fíor Gaotháin Buí",
  "block.minecraft.banner.half_horizontal.black": "Gearrtha, Dubh Thuas",
  "block.minecraft.banner.half_horizontal.blue": "Gearrtha, Gorm Thuas",
  "block.minecraft.banner.half_horizontal.brown": "Gearrtha, Donn Thuas",
  "block.minecraft.banner.half_horizontal.cyan": "Gearrtha, Cian Thuas",
  "block.minecraft.banner.half_horizontal.gray": "Gearrtha, Liath Thuas",
  "block.minecraft.banner.half_horizontal.green": "Gearrtha, Uaine Thuas",
  "block.minecraft.banner.half_horizontal.light_blue": "Gearrtha, Bánghorm Thuas",
  "block.minecraft.banner.half_horizontal.light_gray": "Gearrtha, Fionnliath Thuas",
  "block.minecraft.banner.half_horizontal.lime": "Gearrtha, Glasuaine Thuas",
  "block.minecraft.banner.half_horizontal.magenta": "Gearrtha, Maigeanta Thuas",
  "block.minecraft.banner.half_horizontal.orange": "Gearrtha, Oráiste Thuas",
  "block.minecraft.banner.half_horizontal.pink": "Gearrtha, Bándearg Thuas",
  "block.minecraft.banner.half_horizontal.purple": "Gearrtha, Corcra Thuas",
  "block.minecraft.banner.half_horizontal.red": "Gearrtha, Dearg Thuas",
  "block.minecraft.banner.half_horizontal.white": "Gearrtha, Bán Thuas",
  "block.minecraft.banner.half_horizontal.yellow": "Gearrtha, Buí Thuas",
  "block.minecraft.banner.half_horizontal_bottom.black": "Gearrtha, Dubh Thíos",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Gearrtha, Gorm Thíos",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Gearrtha, Donn Thíos",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Gearrtha, Cian Thíos",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Gearrtha, Liath Thíos",
  "block.minecraft.banner.half_horizontal_bottom.green": "Gearrtha, Uaine Thíos",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Gearrtha, Bánghorm Thíos",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Gearrtha, Fionnliath Thíos",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Gearrtha, Glasuaine Thíos",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Gearrtha, Maigeanta Thíos",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Gearrtha, Oráiste Thíos",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Gearrtha, Bándearg Thíos",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Gearrtha, Corcra Thíos",
  "block.minecraft.banner.half_horizontal_bottom.red": "Gearrtha, Dearg Thíos",
  "block.minecraft.banner.half_horizontal_bottom.white": "Gearrtha, Bán Thíos",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Gearrtha, Buí Thíos",
  "block.minecraft.banner.half_vertical.black": "Deighilte, Dubh ar Dheis",
  "block.minecraft.banner.half_vertical.blue": "Deighilte, Gorm ar Dheis",
  "block.minecraft.banner.half_vertical.brown": "Deighilte, Donn ar Dheis",
  "block.minecraft.banner.half_vertical.cyan": "Deighilte, Cian ar Dheis",
  "block.minecraft.banner.half_vertical.gray": "Deighilte, Liath ar Dheis",
  "block.minecraft.banner.half_vertical.green": "Deighilte, Uaine ar Dheis",
  "block.minecraft.banner.half_vertical.light_blue": "Deighilte, Bánghorm ar Dheis",
  "block.minecraft.banner.half_vertical.light_gray": "Deighilte, Fionnliath ar Dheis",
  "block.minecraft.banner.half_vertical.lime": "Deighilte, Glasuaine ar Dheis",
  "block.minecraft.banner.half_vertical.magenta": "Deighilte, Maigeanta ar Dheis",
  "block.minecraft.banner.half_vertical.orange": "Deighilte, Oráiste ar Dheis",
  "block.minecraft.banner.half_vertical.pink": "Deighilte, Bándearg ar Dheis",
  "block.minecraft.banner.half_vertical.purple": "Deighilte, Corcra ar Dheis",
  "block.minecraft.banner.half_vertical.red": "Deighilte, Dearg ar Dheis",
  "block.minecraft.banner.half_vertical.white": "Deighilte, Bán ar Dheis",
  "block.minecraft.banner.half_vertical.yellow": "Deighilte, Buí ar Dheis",
  "block.minecraft.banner.half_vertical_right.black": "Deighilte, Dubh ar Clé",
  "block.minecraft.banner.half_vertical_right.blue": "Deighilte, Gorm ar Clé",
  "block.minecraft.banner.half_vertical_right.brown": "Deighilte, Donn ar Clé",
  "block.minecraft.banner.half_vertical_right.cyan": "Deighilte, Cian ar Clé",
  "block.minecraft.banner.half_vertical_right.gray": "Deighilte, Liath ar Clé",
  "block.minecraft.banner.half_vertical_right.green": "Deighilte, Uaine ar Clé",
  "block.minecraft.banner.half_vertical_right.light_blue": "Deighilte, Bánghorm ar Clé",
  "block.minecraft.banner.half_vertical_right.light_gray": "Deighilte, Fionnliath ar Clé",
  "block.minecraft.banner.half_vertical_right.lime": "Deighilte, Glasuaine ar Clé",
  "block.minecraft.banner.half_vertical_right.magenta": "Deighilte, Maigeanta ar Clé",
  "block.minecraft.banner.half_vertical_right.orange": "Deighilte, Oráiste ar Clé",
  "block.minecraft.banner.half_vertical_right.pink": "Deighilte, Bándearg ar Clé",
  "block.minecraft.banner.half_vertical_right.purple": "Deighilte, Corcra ar Clé",
  "block.minecraft.banner.half_vertical_right.red": "Deighilte, Dearg ar Clé",
  "block.minecraft.banner.half_vertical_right.white": "Deighilte, Bán ar Clé",
  "block.minecraft.banner.half_vertical_right.yellow": "Deighilte, Buí ar Clé",
  "block.minecraft.banner.mojang.black": "Rud Dubh",
  "block.minecraft.banner.mojang.blue": "Rud Gorm",
  "block.minecraft.banner.mojang.brown": "Rud Donn",
  "block.minecraft.banner.mojang.cyan": "Rud Cian",
  "block.minecraft.banner.mojang.gray": "Rud Liath",
  "block.minecraft.banner.mojang.green": "Rud Uaine",
  "block.minecraft.banner.mojang.light_blue": "Rud Bánghorm",
  "block.minecraft.banner.mojang.light_gray": "Rud Fionnliath",
  "block.minecraft.banner.mojang.lime": "Rud Glasuaine",
  "block.minecraft.banner.mojang.magenta": "Rud Maigeanta",
  "block.minecraft.banner.mojang.orange": "Rud Oráiste",
  "block.minecraft.banner.mojang.pink": "Rud Bándearg",
  "block.minecraft.banner.mojang.purple": "Rud Corcra",
  "block.minecraft.banner.mojang.red": "Rud Dearg",
  "block.minecraft.banner.mojang.white": "Rud Bán",
  "block.minecraft.banner.mojang.yellow": "Rud Buí",
  "block.minecraft.banner.piglin.black": "Soc Dubh",
  "block.minecraft.banner.piglin.blue": "Soc Gorm",
  "block.minecraft.banner.piglin.brown": "Soc Donn",
  "block.minecraft.banner.piglin.cyan": "Soc Cian",
  "block.minecraft.banner.piglin.gray": "Soc Liath",
  "block.minecraft.banner.piglin.green": "Soc Uaine",
  "block.minecraft.banner.piglin.light_blue": "Soc Bánghorm",
  "block.minecraft.banner.piglin.light_gray": "Soc Fionnliath",
  "block.minecraft.banner.piglin.lime": "Soc Glasuaine",
  "block.minecraft.banner.piglin.magenta": "Soc Maigeanta",
  "block.minecraft.banner.piglin.orange": "Soc Oráiste",
  "block.minecraft.banner.piglin.pink": "Soc Bándearg",
  "block.minecraft.banner.piglin.purple": "Soc Corcra",
  "block.minecraft.banner.piglin.red": "Soc Dearg",
  "block.minecraft.banner.piglin.white": "Soc Bán",
  "block.minecraft.banner.piglin.yellow": "Soc Buí",
  "block.minecraft.banner.rhombus.black": "Muileata Dubh",
  "block.minecraft.banner.rhombus.blue": "Muileata Gorm",
  "block.minecraft.banner.rhombus.brown": "Muileata Donn",
  "block.minecraft.banner.rhombus.cyan": "Muileata Cian",
  "block.minecraft.banner.rhombus.gray": "Muileata Liath",
  "block.minecraft.banner.rhombus.green": "Muileata Uaine",
  "block.minecraft.banner.rhombus.light_blue": "Muileata Bánghorm",
  "block.minecraft.banner.rhombus.light_gray": "Muileata Fionnliath",
  "block.minecraft.banner.rhombus.lime": "Muileata Glasuaine",
  "block.minecraft.banner.rhombus.magenta": "Muileata Maigeanta",
  "block.minecraft.banner.rhombus.orange": "Muileata Oráiste",
  "block.minecraft.banner.rhombus.pink": "Muileata Bándearg",
  "block.minecraft.banner.rhombus.purple": "Muileata Corcra",
  "block.minecraft.banner.rhombus.red": "Muileata Dearg",
  "block.minecraft.banner.rhombus.white": "Muileata Bán",
  "block.minecraft.banner.rhombus.yellow": "Muileata Buí",
  "block.minecraft.banner.skull.black": "Fíor Cloiginn Dubh",
  "block.minecraft.banner.skull.blue": "Fíor Cloiginn Gorm",
  "block.minecraft.banner.skull.brown": "Fíor Cloiginn Donn",
  "block.minecraft.banner.skull.cyan": "Fíor Cloiginn Cian",
  "block.minecraft.banner.skull.gray": "Fíor Cloiginn Liath",
  "block.minecraft.banner.skull.green": "Fíor Cloiginn Uaine",
  "block.minecraft.banner.skull.light_blue": "Fíor Cloiginn Bánghorm",
  "block.minecraft.banner.skull.light_gray": "Fíor Cloiginn Fionnliath",
  "block.minecraft.banner.skull.lime": "Fíor Cloiginn Glasuaine",
  "block.minecraft.banner.skull.magenta": "Fíor Cloiginn Maigeanta",
  "block.minecraft.banner.skull.orange": "Fíor Cloiginn Oráiste",
  "block.minecraft.banner.skull.pink": "Fíor Cloiginn Bándearg",
  "block.minecraft.banner.skull.purple": "Fíor Cloiginn Corcra",
  "block.minecraft.banner.skull.red": "Fíor Cloiginn Dearg",
  "block.minecraft.banner.skull.white": "Fíor Cloiginn Bán",
  "block.minecraft.banner.skull.yellow": "Fíor Cloiginn Buí",
  "block.minecraft.banner.small_stripes.black": "Cuailleach Dubh",
  "block.minecraft.banner.small_stripes.blue": "Cuailleach Gorm",
  "block.minecraft.banner.small_stripes.brown": "Cuailleach Donn",
  "block.minecraft.banner.small_stripes.cyan": "Cuailleach Cian",
  "block.minecraft.banner.small_stripes.gray": "Cuailleach Liath",
  "block.minecraft.banner.small_stripes.green": "Cuailleach Uaine",
  "block.minecraft.banner.small_stripes.light_blue": "Cuailleach Bánghorm",
  "block.minecraft.banner.small_stripes.light_gray": "Cuailleach Fionnliath",
  "block.minecraft.banner.small_stripes.lime": "Cuailleach Glasuaine",
  "block.minecraft.banner.small_stripes.magenta": "Cuailleach Maigeanta",
  "block.minecraft.banner.small_stripes.orange": "Cuailleach Oráiste",
  "block.minecraft.banner.small_stripes.pink": "Cuailleach Bándearg",
  "block.minecraft.banner.small_stripes.purple": "Cuailleach Corcra",
  "block.minecraft.banner.small_stripes.red": "Cuailleach Dearg",
  "block.minecraft.banner.small_stripes.white": "Cuailleach Bán",
  "block.minecraft.banner.small_stripes.yellow": "Cuailleach Buí",
  "block.minecraft.banner.square_bottom_left.black": "Cúinneán Dubh Thíos ar Dheis",
  "block.minecraft.banner.square_bottom_left.blue": "Cúinneán Gorm Thíos ar Dheis",
  "block.minecraft.banner.square_bottom_left.brown": "Cúinneán Donn Thíos ar Dheis",
  "block.minecraft.banner.square_bottom_left.cyan": "Cúinneán Cian Thíos ar Dheis",
  "block.minecraft.banner.square_bottom_left.gray": "Cúinneán Liath Thíos ar Dheis",
  "block.minecraft.banner.square_bottom_left.green": "Cúinneán Uaine Thíos ar Dheis",
  "block.minecraft.banner.square_bottom_left.light_blue": "Cúinneán Bánghorm Thíos ar Dheis",
  "block.minecraft.banner.square_bottom_left.light_gray": "Cúinneán Fionnliath Thíos ar Dheis",
  "block.minecraft.banner.square_bottom_left.lime": "Cúinneán Glasuaine Thíos ar Dheis",
  "block.minecraft.banner.square_bottom_left.magenta": "Cúinneán Maigeanta Thíos ar Dheis",
  "block.minecraft.banner.square_bottom_left.orange": "Cúinneán Oráiste Thíos ar Dheis",
  "block.minecraft.banner.square_bottom_left.pink": "Cúinneán Bándearg Thíos ar Dheis",
  "block.minecraft.banner.square_bottom_left.purple": "Cúinneán Corcra Thíos ar Dheis",
  "block.minecraft.banner.square_bottom_left.red": "Cúinneán Dearg Thíos ar Dheis",
  "block.minecraft.banner.square_bottom_left.white": "Cúinneán Bán Thíos ar Dheis",
  "block.minecraft.banner.square_bottom_left.yellow": "Cúinneán Buí Thíos ar Dheis",
  "block.minecraft.banner.square_bottom_right.black": "Cúinneán Dubh Thíos ar Clé",
  "block.minecraft.banner.square_bottom_right.blue": "Cúinneán Gorm Thíos ar Clé",
  "block.minecraft.banner.square_bottom_right.brown": "Cúinneán Donn Thíos ar Clé",
  "block.minecraft.banner.square_bottom_right.cyan": "Cúinneán Cian Thíos ar Clé",
  "block.minecraft.banner.square_bottom_right.gray": "Cúinneán Liath Thíos ar Clé",
  "block.minecraft.banner.square_bottom_right.green": "Cúinneán Uaine Thíos ar Clé",
  "block.minecraft.banner.square_bottom_right.light_blue": "Cúinneán Bánghorm Thíos ar Clé",
  "block.minecraft.banner.square_bottom_right.light_gray": "Cúinneán Fionnliath Thíos ar Clé",
  "block.minecraft.banner.square_bottom_right.lime": "Cúinneán Glasuaine Thíos ar Clé",
  "block.minecraft.banner.square_bottom_right.magenta": "Cúinneán Maigeanta Thíos ar Clé",
  "block.minecraft.banner.square_bottom_right.orange": "Cúinneán Oráiste Thíos ar Clé",
  "block.minecraft.banner.square_bottom_right.pink": "Cúinneán Bándearg Thíos ar Clé",
  "block.minecraft.banner.square_bottom_right.purple": "Cúinneán Corcra Thíos ar Clé",
  "block.minecraft.banner.square_bottom_right.red": "Cúinneán Dearg Thíos ar Clé",
  "block.minecraft.banner.square_bottom_right.white": "Cúinneán Ban Thíos ar Clé",
  "block.minecraft.banner.square_bottom_right.yellow": "Cúinneán Buí Thíos ar Clé",
  "block.minecraft.banner.square_top_left.black": "Cúinneán Dubh Thuas ar Dheis",
  "block.minecraft.banner.square_top_left.blue": "Cúinneán Gorm Thuas ar Dheis",
  "block.minecraft.banner.square_top_left.brown": "Cúinneán Donn Thuas ar Dheis",
  "block.minecraft.banner.square_top_left.cyan": "Cúinneán Cian Thuas ar Dheis",
  "block.minecraft.banner.square_top_left.gray": "Cúinneán Liath Thuas ar Dheis",
  "block.minecraft.banner.square_top_left.green": "Cúinneán Uaine Thuas ar Dheis",
  "block.minecraft.banner.square_top_left.light_blue": "Cúinneán Bánghorm Thuas ar Dheis",
  "block.minecraft.banner.square_top_left.light_gray": "Cúinneán Fionnliath Thuas ar Dheis",
  "block.minecraft.banner.square_top_left.lime": "Cúinneán Glasuaine Thuas ar Dheis",
  "block.minecraft.banner.square_top_left.magenta": "Cúinneán Maigeanta Thuas ar Dheis",
  "block.minecraft.banner.square_top_left.orange": "Cúinneán Oráiste Thuas ar Dheis",
  "block.minecraft.banner.square_top_left.pink": "Cúinneán Bándearg Thuas ar Dheis",
  "block.minecraft.banner.square_top_left.purple": "Cúinneán Corcra Thuas ar Dheis",
  "block.minecraft.banner.square_top_left.red": "Cúinneán Dearg Thuas ar Dheis",
  "block.minecraft.banner.square_top_left.white": "Cúinneán Bán Thuas ar Dheis",
  "block.minecraft.banner.square_top_left.yellow": "Cúinneán Buí Thuas ar Dheis",
  "block.minecraft.banner.square_top_right.black": "Cúinneán Dubh Thuas ar Clé",
  "block.minecraft.banner.square_top_right.blue": "Cúinneán Gorm Thuas ar Clé",
  "block.minecraft.banner.square_top_right.brown": "Cúinneán Donn Thuas ar Clé",
  "block.minecraft.banner.square_top_right.cyan": "Cúinneán Cian Thuas ar Clé",
  "block.minecraft.banner.square_top_right.gray": "Cúinneán Liath Thuas ar Clé",
  "block.minecraft.banner.square_top_right.green": "Cúinneán Uaine Thuas ar Clé",
  "block.minecraft.banner.square_top_right.light_blue": "Cúinneán Bánghorm Thuas ar Clé",
  "block.minecraft.banner.square_top_right.light_gray": "Cúinneán Fionnliath Thuas ar Clé",
  "block.minecraft.banner.square_top_right.lime": "Cúinneán Glasuaine Thuas ar Clé",
  "block.minecraft.banner.square_top_right.magenta": "Cúinneán Maigeanta Thuas ar Clé",
  "block.minecraft.banner.square_top_right.orange": "Cúinneán Oráiste Thuas ar Clé",
  "block.minecraft.banner.square_top_right.pink": "Cúinneán Bándearg Thuas ar Clé",
  "block.minecraft.banner.square_top_right.purple": "Cúinneán Corcra Thuas ar Clé",
  "block.minecraft.banner.square_top_right.red": "Cúinneán Dearg Thuas ar Clé",
  "block.minecraft.banner.square_top_right.white": "Cúinneán Bán Thuas ar Clé",
  "block.minecraft.banner.square_top_right.yellow": "Cúinneán Buí Thuas ar Clé",
  "block.minecraft.banner.straight_cross.black": "Cros Dhubh",
  "block.minecraft.banner.straight_cross.blue": "Cros Ghorm",
  "block.minecraft.banner.straight_cross.brown": "Cros Dhonn",
  "block.minecraft.banner.straight_cross.cyan": "Cros Chian",
  "block.minecraft.banner.straight_cross.gray": "Cros Liath",
  "block.minecraft.banner.straight_cross.green": "Cros Uaine",
  "block.minecraft.banner.straight_cross.light_blue": "Cros Bhánghorm",
  "block.minecraft.banner.straight_cross.light_gray": "Cros Fhionnliath",
  "block.minecraft.banner.straight_cross.lime": "Cros Ghlasuaine",
  "block.minecraft.banner.straight_cross.magenta": "Cros Mhaigeanta",
  "block.minecraft.banner.straight_cross.orange": "Cros Oráiste",
  "block.minecraft.banner.straight_cross.pink": "Cros Bhándearg",
  "block.minecraft.banner.straight_cross.purple": "Cros Chorcra",
  "block.minecraft.banner.straight_cross.red": "Cros Dhearg",
  "block.minecraft.banner.straight_cross.white": "Cros Bhán",
  "block.minecraft.banner.straight_cross.yellow": "Cros Bhuí",
  "block.minecraft.banner.stripe_bottom.black": "Bun Dubh",
  "block.minecraft.banner.stripe_bottom.blue": "Bun Gorm",
  "block.minecraft.banner.stripe_bottom.brown": "Bun Donn",
  "block.minecraft.banner.stripe_bottom.cyan": "Bun Cian",
  "block.minecraft.banner.stripe_bottom.gray": "Bun Liath",
  "block.minecraft.banner.stripe_bottom.green": "Bun Uaine",
  "block.minecraft.banner.stripe_bottom.light_blue": "Bun Bánghorm",
  "block.minecraft.banner.stripe_bottom.light_gray": "Bun Fionnliath",
  "block.minecraft.banner.stripe_bottom.lime": "Bun Glasuaine",
  "block.minecraft.banner.stripe_bottom.magenta": "Bun Maigeanta",
  "block.minecraft.banner.stripe_bottom.orange": "Bun Oráiste",
  "block.minecraft.banner.stripe_bottom.pink": "Bun Bándearg",
  "block.minecraft.banner.stripe_bottom.purple": "Bun Corcra",
  "block.minecraft.banner.stripe_bottom.red": "Bun Dearg",
  "block.minecraft.banner.stripe_bottom.white": "Bun Bán",
  "block.minecraft.banner.stripe_bottom.yellow": "Bun Buí",
  "block.minecraft.banner.stripe_center.black": "Cuaille Dubh",
  "block.minecraft.banner.stripe_center.blue": "Cuaille Gorm",
  "block.minecraft.banner.stripe_center.brown": "Cuaille Donn",
  "block.minecraft.banner.stripe_center.cyan": "Cuaille Cian",
  "block.minecraft.banner.stripe_center.gray": "Cuaille Liath",
  "block.minecraft.banner.stripe_center.green": "Cuaille Uaine",
  "block.minecraft.banner.stripe_center.light_blue": "Cuaille Bánghorm",
  "block.minecraft.banner.stripe_center.light_gray": "Cuaille Fionnliath",
  "block.minecraft.banner.stripe_center.lime": "Cuaille Glasuaine",
  "block.minecraft.banner.stripe_center.magenta": "Cuaille Maigeanta",
  "block.minecraft.banner.stripe_center.orange": "Cuaille Oráiste",
  "block.minecraft.banner.stripe_center.pink": "Cuaille Bándearg",
  "block.minecraft.banner.stripe_center.purple": "Cuaille Corcra",
  "block.minecraft.banner.stripe_center.red": "Cuaille Dearg",
  "block.minecraft.banner.stripe_center.white": "Cuaille Bán",
  "block.minecraft.banner.stripe_center.yellow": "Cuaille Buí",
  "block.minecraft.banner.stripe_downleft.black": "Clébhandán Dubh",
  "block.minecraft.banner.stripe_downleft.blue": "Clébhandán Gorm",
  "block.minecraft.banner.stripe_downleft.brown": "Clébhandán Donn",
  "block.minecraft.banner.stripe_downleft.cyan": "Clébhandán Cian",
  "block.minecraft.banner.stripe_downleft.gray": "Clébhandán Liath",
  "block.minecraft.banner.stripe_downleft.green": "Clébhandán Uaine",
  "block.minecraft.banner.stripe_downleft.light_blue": "Clébhandán Bánghorm",
  "block.minecraft.banner.stripe_downleft.light_gray": "Clébhandán Fionnliath",
  "block.minecraft.banner.stripe_downleft.lime": "Clébhandán Glasuaine",
  "block.minecraft.banner.stripe_downleft.magenta": "Clébhandán Maigeanta",
  "block.minecraft.banner.stripe_downleft.orange": "Clébhandán Oráiste",
  "block.minecraft.banner.stripe_downleft.pink": "Clébhandán Bándearg",
  "block.minecraft.banner.stripe_downleft.purple": "Clébhandán Corcra",
  "block.minecraft.banner.stripe_downleft.red": "Clébhandán Dearg",
  "block.minecraft.banner.stripe_downleft.white": "Clébhandán Bán",
  "block.minecraft.banner.stripe_downleft.yellow": "Clébhandán Buí",
  "block.minecraft.banner.stripe_downright.black": "Bandán Dubh",
  "block.minecraft.banner.stripe_downright.blue": "Bandán Gorm",
  "block.minecraft.banner.stripe_downright.brown": "Bandán Donn",
  "block.minecraft.banner.stripe_downright.cyan": "Bandán Cian",
  "block.minecraft.banner.stripe_downright.gray": "Bandán Liath",
  "block.minecraft.banner.stripe_downright.green": "Bandán Uaine",
  "block.minecraft.banner.stripe_downright.light_blue": "Bandán Bánghorm",
  "block.minecraft.banner.stripe_downright.light_gray": "Bandán Fionnliath",
  "block.minecraft.banner.stripe_downright.lime": "Bandán Glasuaine",
  "block.minecraft.banner.stripe_downright.magenta": "Bandán Maigeanta",
  "block.minecraft.banner.stripe_downright.orange": "Bandán Oráiste",
  "block.minecraft.banner.stripe_downright.pink": "Bandán Bándearg",
  "block.minecraft.banner.stripe_downright.purple": "Bandán Corcra",
  "block.minecraft.banner.stripe_downright.red": "Bandán Dearg",
  "block.minecraft.banner.stripe_downright.white": "Bandán Bán",
  "block.minecraft.banner.stripe_downright.yellow": "Bandán Buí",
  "block.minecraft.banner.stripe_left.black": "Cuaille Dubh ar Dheis",
  "block.minecraft.banner.stripe_left.blue": "Cuaille Gorm ar Dheis",
  "block.minecraft.banner.stripe_left.brown": "Cuaille Donn ar Dheis",
  "block.minecraft.banner.stripe_left.cyan": "Cuaille Cian ar Dheis",
  "block.minecraft.banner.stripe_left.gray": "Cuaille Liath ar Dheis",
  "block.minecraft.banner.stripe_left.green": "Cuaille Uaine ar Dheis",
  "block.minecraft.banner.stripe_left.light_blue": "Cuaille Bánghorm ar Dheis",
  "block.minecraft.banner.stripe_left.light_gray": "Cuaille Fionnliath ar Dheis",
  "block.minecraft.banner.stripe_left.lime": "Cuaille Glasuaine ar Dheis",
  "block.minecraft.banner.stripe_left.magenta": "Cuaille Maigeanta ar Dheis",
  "block.minecraft.banner.stripe_left.orange": "Cuaille Oráiste ar Dheis",
  "block.minecraft.banner.stripe_left.pink": "Cuaille Bándearg ar Dheis",
  "block.minecraft.banner.stripe_left.purple": "Cuaille Corcra ar Dheis",
  "block.minecraft.banner.stripe_left.red": "Cuaille Dearg ar Dheis",
  "block.minecraft.banner.stripe_left.white": "Cuaille Bán ar Dheis",
  "block.minecraft.banner.stripe_left.yellow": "Cuaille Buí ar Dheis",
  "block.minecraft.banner.stripe_middle.black": "Balc Dubh",
  "block.minecraft.banner.stripe_middle.blue": "Balc Gorm",
  "block.minecraft.banner.stripe_middle.brown": "Balc Donn",
  "block.minecraft.banner.stripe_middle.cyan": "Balc Cian",
  "block.minecraft.banner.stripe_middle.gray": "Balc Liath",
  "block.minecraft.banner.stripe_middle.green": "Balc Uaine",
  "block.minecraft.banner.stripe_middle.light_blue": "Balc Bánghorm",
  "block.minecraft.banner.stripe_middle.light_gray": "Balc Fionnliath",
  "block.minecraft.banner.stripe_middle.lime": "Balc Glasuaine",
  "block.minecraft.banner.stripe_middle.magenta": "Balc Maigeanta",
  "block.minecraft.banner.stripe_middle.orange": "Balc Oráiste",
  "block.minecraft.banner.stripe_middle.pink": "Balc Bándearg",
  "block.minecraft.banner.stripe_middle.purple": "Balc Corcra",
  "block.minecraft.banner.stripe_middle.red": "Balc Dearg",
  "block.minecraft.banner.stripe_middle.white": "Balc Bán",
  "block.minecraft.banner.stripe_middle.yellow": "Balc Buí",
  "block.minecraft.banner.stripe_right.black": "Cuaille Dubh ar Clé",
  "block.minecraft.banner.stripe_right.blue": "Cuaille Gorm ar Clé",
  "block.minecraft.banner.stripe_right.brown": "Cuaille Donn ar Clé",
  "block.minecraft.banner.stripe_right.cyan": "Cuaille Cian ar Clé",
  "block.minecraft.banner.stripe_right.gray": "Cuaille Liath ar Clé",
  "block.minecraft.banner.stripe_right.green": "Cuaille Uaine ar Clé",
  "block.minecraft.banner.stripe_right.light_blue": "Cuaille Bánghorm ar Clé",
  "block.minecraft.banner.stripe_right.light_gray": "Cuaille Fionnliath ar Clé",
  "block.minecraft.banner.stripe_right.lime": "Cuaille Glasuaine ar Clé",
  "block.minecraft.banner.stripe_right.magenta": "Cuaille Maigeanta ar Clé",
  "block.minecraft.banner.stripe_right.orange": "Cuaille Oráiste ar Clé",
  "block.minecraft.banner.stripe_right.pink": "Cuaille Bándearg ar Clé",
  "block.minecraft.banner.stripe_right.purple": "Cuaille Corcra ar Clé",
  "block.minecraft.banner.stripe_right.red": "Cuaille Dearg ar Clé",
  "block.minecraft.banner.stripe_right.white": "Cuaille Bán ar Clé",
  "block.minecraft.banner.stripe_right.yellow": "Cuaille Buí ar Clé",
  "block.minecraft.banner.stripe_top.black": "Barr Dubh",
  "block.minecraft.banner.stripe_top.blue": "Barr Gorm",
  "block.minecraft.banner.stripe_top.brown": "Barr Donn",
  "block.minecraft.banner.stripe_top.cyan": "Barr Cian",
  "block.minecraft.banner.stripe_top.gray": "Barr Liath",
  "block.minecraft.banner.stripe_top.green": "Barr Uaine",
  "block.minecraft.banner.stripe_top.light_blue": "Barr Bánghorm",
  "block.minecraft.banner.stripe_top.light_gray": "Barr Fionnliath",
  "block.minecraft.banner.stripe_top.lime": "Barr Glasuaine",
  "block.minecraft.banner.stripe_top.magenta": "Barr Maigeanta",
  "block.minecraft.banner.stripe_top.orange": "Barr Oráiste",
  "block.minecraft.banner.stripe_top.pink": "Barr Bándearg",
  "block.minecraft.banner.stripe_top.purple": "Barr Corcra",
  "block.minecraft.banner.stripe_top.red": "Barr Dearg",
  "block.minecraft.banner.stripe_top.white": "Barr Bán",
  "block.minecraft.banner.stripe_top.yellow": "Barr Buí",
  "block.minecraft.banner.triangle_bottom.black": "Binnroinnte Dubh",
  "block.minecraft.banner.triangle_bottom.blue": "Binnroinnte Gorm",
  "block.minecraft.banner.triangle_bottom.brown": "Binnroinnte Donn",
  "block.minecraft.banner.triangle_bottom.cyan": "Binnroinnte Cian",
  "block.minecraft.banner.triangle_bottom.gray": "Binnroinnte Liath",
  "block.minecraft.banner.triangle_bottom.green": "Binnroinnte Uaine",
  "block.minecraft.banner.triangle_bottom.light_blue": "Binnroinnte Bánghorm",
  "block.minecraft.banner.triangle_bottom.light_gray": "Binnroinnte Fionnliath",
  "block.minecraft.banner.triangle_bottom.lime": "Binnroinnte Glasuaine",
  "block.minecraft.banner.triangle_bottom.magenta": "Binnroinnte Maigeanta",
  "block.minecraft.banner.triangle_bottom.orange": "Binnroinnte Oráiste",
  "block.minecraft.banner.triangle_bottom.pink": "Binnroinnte Bándearg",
  "block.minecraft.banner.triangle_bottom.purple": "Binnroinnte Corcra",
  "block.minecraft.banner.triangle_bottom.red": "Binnroinnte Dearg",
  "block.minecraft.banner.triangle_bottom.white": "Binnroinnte Bán",
  "block.minecraft.banner.triangle_bottom.yellow": "Binnroinnte Buí",
  "block.minecraft.banner.triangle_top.black": "Binnroinnte Bunoscionn Dubh",
  "block.minecraft.banner.triangle_top.blue": "Binnroinnte Bunoscionn Gorm",
  "block.minecraft.banner.triangle_top.brown": "Binnroinnte Bunoscionn Donn",
  "block.minecraft.banner.triangle_top.cyan": "Binnroinnte Bunoscionn Cian",
  "block.minecraft.banner.triangle_top.gray": "Binnroinnte Bunoscionn Liath",
  "block.minecraft.banner.triangle_top.green": "Binnroinnte Bunoscionn Uaine",
  "block.minecraft.banner.triangle_top.light_blue": "Binnroinnte Bunoscionn Bánghorm",
  "block.minecraft.banner.triangle_top.light_gray": "Binnroinnte Bunoscionn Fionnliath",
  "block.minecraft.banner.triangle_top.lime": "Binnroinnte Bunoscionn Glasuaine",
  "block.minecraft.banner.triangle_top.magenta": "Binnroinnte Bunoscionn Maigeanta",
  "block.minecraft.banner.triangle_top.orange": "Binnroinnte Bunoscionn Oráiste",
  "block.minecraft.banner.triangle_top.pink": "Binnroinnte Bunoscionn Bándearg",
  "block.minecraft.banner.triangle_top.purple": "Binnroinnte Bunoscionn Corcra",
  "block.minecraft.banner.triangle_top.red": "Binnroinnte Bunoscionn Dearg",
  "block.minecraft.banner.triangle_top.white": "Binnroinnte Bunoscionn Bán",
  "block.minecraft.banner.triangle_top.yellow": "Binnroinnte Bunoscionn Buí",
  "block.minecraft.banner.triangles_bottom.black": "Bun Eangach Dubh",
  "block.minecraft.banner.triangles_bottom.blue": "Bun Eangach Gorm",
  "block.minecraft.banner.triangles_bottom.brown": "Bun Eangach Donn",
  "block.minecraft.banner.triangles_bottom.cyan": "Bun Eangach Cian",
  "block.minecraft.banner.triangles_bottom.gray": "Bun Eangach Liath",
  "block.minecraft.banner.triangles_bottom.green": "Bun Eangach Uaine",
  "block.minecraft.banner.triangles_bottom.light_blue": "Bun Eangach Bánghorm",
  "block.minecraft.banner.triangles_bottom.light_gray": "Bun Eangach Fionnliath",
  "block.minecraft.banner.triangles_bottom.lime": "Bun Eangach Glasuaine",
  "block.minecraft.banner.triangles_bottom.magenta": "Bun Eangach Maigeanta",
  "block.minecraft.banner.triangles_bottom.orange": "Bun Eangach Oráiste",
  "block.minecraft.banner.triangles_bottom.pink": "Bun Eangach Bándearg",
  "block.minecraft.banner.triangles_bottom.purple": "Bun Eangach Corcra",
  "block.minecraft.banner.triangles_bottom.red": "Bun Eangach Dearg",
  "block.minecraft.banner.triangles_bottom.white": "Bun Eangach Bán",
  "block.minecraft.banner.triangles_bottom.yellow": "Bun Eangach Buí",
  "block.minecraft.banner.triangles_top.black": "Barr Eangach Dubh",
  "block.minecraft.banner.triangles_top.blue": "Barr Eangach Gorm",
  "block.minecraft.banner.triangles_top.brown": "Barr Eangach Donn",
  "block.minecraft.banner.triangles_top.cyan": "Barr Eangach Cian",
  "block.minecraft.banner.triangles_top.gray": "Barr Eangach Liath",
  "block.minecraft.banner.triangles_top.green": "Barr Eangach Uaine",
  "block.minecraft.banner.triangles_top.light_blue": "Barr Eangach Bánghorm",
  "block.minecraft.banner.triangles_top.light_gray": "Barr Eangach Fionnliath",
  "block.minecraft.banner.triangles_top.lime": "Barr Eangach Glasuaine",
  "block.minecraft.banner.triangles_top.magenta": "Barr Eangach Maigeanta",
  "block.minecraft.banner.triangles_top.orange": "Barr Eangach Oráiste",
  "block.minecraft.banner.triangles_top.pink": "Barr Eangach Bándearg",
  "block.minecraft.banner.triangles_top.purple": "Barr Eangach Corcra",
  "block.minecraft.banner.triangles_top.red": "Barr Eangach Dearg",
  "block.minecraft.banner.triangles_top.white": "Barr Eangach Bán",
  "block.minecraft.banner.triangles_top.yellow": "Barr Eangach Buí",
  "block.minecraft.barrel": "Bairille",
  "block.minecraft.barrier": "Bac",
  "block.minecraft.basalt": "Basalt",
  "block.minecraft.beacon": "Rabhchán",
  "block.minecraft.beacon.primary": "Príomh-chumhacht",
  "block.minecraft.beacon.secondary": "Fo-chumhacht",
  "block.minecraft.bed.no_sleep": "Ní féidir leat codladh ach istoíche is i rith stoirmeacha",
  "block.minecraft.bed.not_safe": "Ní féidir leat do scíth a ligean anois, tá arrachtaí in aice leat",
  "block.minecraft.bed.obstructed": "Tá bac ar an leaba seo",
  "block.minecraft.bed.occupied": "Tá an leaba seo gafa",
  "block.minecraft.bed.too_far_away": "Ní féidir scíth a ligean anois, tá an leaba rófhada uait",
  "block.minecraft.bedrock": "Buncharraig",
  "block.minecraft.bee_nest": "Nead Beach",
  "block.minecraft.beehive": "Coirceog",
  "block.minecraft.beetroots": "Biatas",
  "block.minecraft.bell": "Clog",
  "block.minecraft.big_dripleaf": "Duille Silte Mór",
  "block.minecraft.big_dripleaf_stem": "Gas Duille Shilte Mhóir",
  "block.minecraft.birch_button": "Cnaipe Beithe",
  "block.minecraft.birch_door": "Doras Beithe",
  "block.minecraft.birch_fence": "Claí Beithe",
  "block.minecraft.birch_fence_gate": "Geata Beithe",
  "block.minecraft.birch_hanging_sign": "Comhartha Crochta Beithe",
  "block.minecraft.birch_leaves": "Duilleoga Beithe",
  "block.minecraft.birch_log": "Bloc Beithe",
  "block.minecraft.birch_planks": "Cláir Bheithe",
  "block.minecraft.birch_pressure_plate": "Brúphláta Beithe",
  "block.minecraft.birch_sapling": "Buinneán Beithe",
  "block.minecraft.birch_shelf": "Seilf Bheithe",
  "block.minecraft.birch_sign": "Comhartha Beithe",
  "block.minecraft.birch_slab": "Leac Bheithe",
  "block.minecraft.birch_stairs": "Staighre Beithe",
  "block.minecraft.birch_trapdoor": "Comhla Bheithe",
  "block.minecraft.birch_wall_hanging_sign": "Comhartha Crochta Balla Beithe",
  "block.minecraft.birch_wall_sign": "Comhartha Balla Beithe",
  "block.minecraft.birch_wood": "Adhmad Beithe",
  "block.minecraft.black_banner": "Meirge Dubh",
  "block.minecraft.black_bed": "Leaba Dhubh",
  "block.minecraft.black_candle": "Coinneal Dhubh",
  "block.minecraft.black_candle_cake": "Cáca le Coinneal Dhubh",
  "block.minecraft.black_carpet": "Cairpéad Dubh",
  "block.minecraft.black_concrete": "Coincréit Dhubh",
  "block.minecraft.black_concrete_powder": "Púdar Coincréite Dubh",
  "block.minecraft.black_glazed_terracotta": "Cré Ghlónraithe Dhubh",
  "block.minecraft.black_shulker_box": "Bosca Shulker Dubh",
  "block.minecraft.black_stained_glass": "Gloine Dhubh",
  "block.minecraft.black_stained_glass_pane": "Pána Dubh",
  "block.minecraft.black_terracotta": "Cré Bhruite Dhubh",
  "block.minecraft.black_wool": "Olann Dhubh",
  "block.minecraft.blackstone": "Dúchloch",
  "block.minecraft.blackstone_slab": "Leac Dhúchloiche",
  "block.minecraft.blackstone_stairs": "Staighre Dúchloiche",
  "block.minecraft.blackstone_wall": "Balla Dúchloiche",
  "block.minecraft.blast_furnace": "Foirnéis Soinneáin",
  "block.minecraft.blue_banner": "Meirge Gorm",
  "block.minecraft.blue_bed": "Leaba Ghorm",
  "block.minecraft.blue_candle": "Coinneal Ghorm",
  "block.minecraft.blue_candle_cake": "Cáca le Coinneal Ghorm",
  "block.minecraft.blue_carpet": "Cairpéad Gorm",
  "block.minecraft.blue_concrete": "Coincréit Ghorm",
  "block.minecraft.blue_concrete_powder": "Púdar Coincréite Gorm",
  "block.minecraft.blue_glazed_terracotta": "Cré Ghlónraithe Ghorm",
  "block.minecraft.blue_ice": "Oighear Gorm",
  "block.minecraft.blue_orchid": "Magairlín Gorm",
  "block.minecraft.blue_shulker_box": "Bosca Shulker Gorm",
  "block.minecraft.blue_stained_glass": "Gloine Ghorm",
  "block.minecraft.blue_stained_glass_pane": "Pána Gorm",
  "block.minecraft.blue_terracotta": "Cré Bhruite Ghorm",
  "block.minecraft.blue_wool": "Olann Ghorm",
  "block.minecraft.bone_block": "Bloc Cnáimhe",
  "block.minecraft.bookshelf": "Seilf Leabhar",
  "block.minecraft.brain_coral": "Coiréalach Inchinne",
  "block.minecraft.brain_coral_block": "Bloc Coiréalaigh Inchinne",
  "block.minecraft.brain_coral_fan": "Fean Coiréalaigh Inchinne",
  "block.minecraft.brain_coral_wall_fan": "Fean Balla Coiréalaigh Inchinne",
  "block.minecraft.brewing_stand": "Stil",
  "block.minecraft.brick_slab": "Leac Brící",
  "block.minecraft.brick_stairs": "Staighre Brící",
  "block.minecraft.brick_wall": "Balla Brící",
  "block.minecraft.bricks": "Brící",
  "block.minecraft.brown_banner": "Meirge Donn",
  "block.minecraft.brown_bed": "Leaba Dhonn",
  "block.minecraft.brown_candle": "Coinneal Dhonn",
  "block.minecraft.brown_candle_cake": "Cáca le Coinneal Dhonn",
  "block.minecraft.brown_carpet": "Cairpéad Donn",
  "block.minecraft.brown_concrete": "Coincréit Dhonn",
  "block.minecraft.brown_concrete_powder": "Púdar Coincréite Donn",
  "block.minecraft.brown_glazed_terracotta": "Cré Ghlónraithe Dhonn",
  "block.minecraft.brown_mushroom": "Beacán Donn",
  "block.minecraft.brown_mushroom_block": "Bloc Beacáin Dhoinn",
  "block.minecraft.brown_shulker_box": "Bosca Shulker Donn",
  "block.minecraft.brown_stained_glass": "Gloine Dhonn",
  "block.minecraft.brown_stained_glass_pane": "Pána Donn",
  "block.minecraft.brown_terracotta": "Cré Bhruite Dhonn",
  "block.minecraft.brown_wool": "Olann Dhonn",
  "block.minecraft.bubble_column": "Colún Bolgán",
  "block.minecraft.bubble_coral": "Coiréalach Bolgóideach",
  "block.minecraft.bubble_coral_block": "Bloc Coiréalaigh Bholgóidigh",
  "block.minecraft.bubble_coral_fan": "Fean Coiréalaigh Bholgóidigh",
  "block.minecraft.bubble_coral_wall_fan": "Fean Balla Coiréalaigh Bholgóidigh",
  "block.minecraft.budding_amethyst": "Aimitis Bhachlógach",
  "block.minecraft.bush": "Tom",
  "block.minecraft.cactus": "Cachtas",
  "block.minecraft.cactus_flower": "Bláth Cachtais",
  "block.minecraft.cake": "Cáca",
  "block.minecraft.calcite": "Cailcít",
  "block.minecraft.calibrated_sculk_sensor": "Braiteoir Sculk Calabraithe",
  "block.minecraft.campfire": "Tine Champa",
  "block.minecraft.candle": "Coinneal",
  "block.minecraft.candle_cake": "Cáca le Coinneal",
  "block.minecraft.carrots": "Cairéid",
  "block.minecraft.cartography_table": "Bord Cartagrafaíochta",
  "block.minecraft.carved_pumpkin": "Puimcín Snoite",
  "block.minecraft.cauldron": "Coire",
  "block.minecraft.cave_air": "Aer Uaimhe",
  "block.minecraft.cave_vines": "Féithleog Uaimhe",
  "block.minecraft.cave_vines_plant": "Planda Féithleoige Uaimhe",
  "block.minecraft.chain": "Slabhra",
  "block.minecraft.chain_command_block": "Bloc Ordaithe Slabhrach",
  "block.minecraft.cherry_button": "Cnaipe Silín",
  "block.minecraft.cherry_door": "Doras Silín",
  "block.minecraft.cherry_fence": "Claí Silín",
  "block.minecraft.cherry_fence_gate": "Geata Silín",
  "block.minecraft.cherry_hanging_sign": "Comhartha Crochta Silín",
  "block.minecraft.cherry_leaves": "Duilleoga Silín",
  "block.minecraft.cherry_log": "Bloc Silín",
  "block.minecraft.cherry_planks": "Cláir Shilín",
  "block.minecraft.cherry_pressure_plate": "Brúphláta Silín",
  "block.minecraft.cherry_sapling": "Buinneán Silín",
  "block.minecraft.cherry_shelf": "Seilf Shilín",
  "block.minecraft.cherry_sign": "Comhartha Silín",
  "block.minecraft.cherry_slab": "Leac Shilín",
  "block.minecraft.cherry_stairs": "Staighre Silín",
  "block.minecraft.cherry_trapdoor": "Comhla Shilín",
  "block.minecraft.cherry_wall_hanging_sign": "Comhartha Crochta Balla Silín",
  "block.minecraft.cherry_wall_sign": "Comhartha Balla Silín",
  "block.minecraft.cherry_wood": "Adhmad Silín",
  "block.minecraft.chest": "Cófra",
  "block.minecraft.chipped_anvil": "Inneoin Scealptha",
  "block.minecraft.chiseled_bookshelf": "Seilf Leabhar Shiséalta",
  "block.minecraft.chiseled_copper": "Copar Siséalta",
  "block.minecraft.chiseled_deepslate": "Dúshlinn Shiséalta",
  "block.minecraft.chiseled_nether_bricks": "Brící Nether Siséalta",
  "block.minecraft.chiseled_polished_blackstone": "Dúchloch Shnasta Shiséalta",
  "block.minecraft.chiseled_quartz_block": "Bloc Grianchloiche Siséalta",
  "block.minecraft.chiseled_red_sandstone": "Gaineamhchloch Rua Shiséalta",
  "block.minecraft.chiseled_resin_bricks": "Brící Roisín Siséalta",
  "block.minecraft.chiseled_sandstone": "Gaineamhchloch Shiséalta",
  "block.minecraft.chiseled_stone_bricks": "Brící Cloiche Siséalta",
  "block.minecraft.chiseled_tuff": "Tuf Siséalta",
  "block.minecraft.chiseled_tuff_bricks": "Brící Tuf Siséalta",
  "block.minecraft.chorus_flower": "Bláth an Cheoil",
  "block.minecraft.chorus_plant": "Crann an Cheoil",
  "block.minecraft.clay": "Cré",
  "block.minecraft.closed_eyeblossom": "Bláth na Súl Dúnta",
  "block.minecraft.coal_block": "Bloc Guail",
  "block.minecraft.coal_ore": "Mian Ghuail",
  "block.minecraft.coarse_dirt": "Ithir Gharbh",
  "block.minecraft.cobbled_deepslate": "Dúshlinn Dhoirneogach",
  "block.minecraft.cobbled_deepslate_slab": "Leac Dúshlinne Doirneogaí",
  "block.minecraft.cobbled_deepslate_stairs": "Staighre Dúshlinne Doirneogaí",
  "block.minecraft.cobbled_deepslate_wall": "Balla Dúshlinne Doirneogaí",
  "block.minecraft.cobblestone": "Doirneog",
  "block.minecraft.cobblestone_slab": "Leac Dhoirneoige",
  "block.minecraft.cobblestone_stairs": "Staighre Doirneoige",
  "block.minecraft.cobblestone_wall": "Balla Doirneoige",
  "block.minecraft.cobweb": "Gréasán Damháin Alla",
  "block.minecraft.cocoa": "Cócó",
  "block.minecraft.command_block": "Bloc Ordaithe",
  "block.minecraft.comparator": "Comparadóir Redstone",
  "block.minecraft.composter": "Múiríneoir",
  "block.minecraft.conduit": "Seolphíopa",
  "block.minecraft.copper_bars": "Barraí Copair",
  "block.minecraft.copper_block": "Bloc Copair",
  "block.minecraft.copper_bulb": "Bolgán Copair",
  "block.minecraft.copper_chain": "Slabhra Copair",
  "block.minecraft.copper_chest": "Cófra Copair",
  "block.minecraft.copper_door": "Doras Copair",
  "block.minecraft.copper_golem_statue": "Dealbh de Ghólam Copair",
  "block.minecraft.copper_grate": "Gráta Copair",
  "block.minecraft.copper_lantern": "Laindéar Copair",
  "block.minecraft.copper_ore": "Mian Chopair",
  "block.minecraft.copper_torch": "Tóirse Copair",
  "block.minecraft.copper_trapdoor": "Comhla Chopair",
  "block.minecraft.copper_wall_torch": "Tóirse Balla Copair",
  "block.minecraft.cornflower": "Gormán",
  "block.minecraft.cracked_deepslate_bricks": "Brící Dúshlinne Scoilte",
  "block.minecraft.cracked_deepslate_tiles": "Leacáin Dúshlinne Scoilte",
  "block.minecraft.cracked_nether_bricks": "Brící Nether Scoilte",
  "block.minecraft.cracked_polished_blackstone_bricks": "Brící Dúchloiche Snasta Scoilte",
  "block.minecraft.cracked_stone_bricks": "Brící Cloiche Scoilte",
  "block.minecraft.crafter": "Ceardaí",
  "block.minecraft.crafting_table": "Bord Ceardaíochta",
  "block.minecraft.creaking_heart": "Croí an Díoscánaí",
  "block.minecraft.creeper_head": "Ceann Creeper",
  "block.minecraft.creeper_wall_head": "Ceann Balla Creeper",
  "block.minecraft.crimson_button": "Cnaipe Craorag",
  "block.minecraft.crimson_door": "Doras Craorag",
  "block.minecraft.crimson_fence": "Claí Craorag",
  "block.minecraft.crimson_fence_gate": "Geata Craorag",
  "block.minecraft.crimson_fungus": "Fungas Craorag",
  "block.minecraft.crimson_hanging_sign": "Comhartha Crochta Craorag",
  "block.minecraft.crimson_hyphae": "Hífí Craoraga",
  "block.minecraft.crimson_nylium": "Níliam Craorag",
  "block.minecraft.crimson_planks": "Cláir Chraoraga",
  "block.minecraft.crimson_pressure_plate": "Brúphláta Craorag",
  "block.minecraft.crimson_roots": "Fréamhach Craorag",
  "block.minecraft.crimson_shelf": "Seilf Chraorag",
  "block.minecraft.crimson_sign": "Comhartha Craorag",
  "block.minecraft.crimson_slab": "Leac Chraorag",
  "block.minecraft.crimson_stairs": "Staighre Craorag",
  "block.minecraft.crimson_stem": "Gas Craorag",
  "block.minecraft.crimson_trapdoor": "Comhla Chraorag",
  "block.minecraft.crimson_wall_hanging_sign": "Comhartha Crochta Balla Craorag",
  "block.minecraft.crimson_wall_sign": "Comhartha Balla Craorag",
  "block.minecraft.crying_obsidian": "Obsaidian Caointe",
  "block.minecraft.cut_copper": "Copar Gearrtha",
  "block.minecraft.cut_copper_slab": "Leac Copair Ghearrtha",
  "block.minecraft.cut_copper_stairs": "Staighre Copair Ghearrtha",
  "block.minecraft.cut_red_sandstone": "Gaineamhchloch Rua Ghearrtha",
  "block.minecraft.cut_red_sandstone_slab": "Leac Gaineamhchloiche Rua Gearrtha",
  "block.minecraft.cut_sandstone": "Gaineamhchloch Ghearrtha",
  "block.minecraft.cut_sandstone_slab": "Leac Gaineamhchloiche Gearrtha",
  "block.minecraft.cyan_banner": "Meirge Cian",
  "block.minecraft.cyan_bed": "Leaba Chian",
  "block.minecraft.cyan_candle": "Coinneal Chian",
  "block.minecraft.cyan_candle_cake": "Cáca le Coinneal Chian",
  "block.minecraft.cyan_carpet": "Cairpéad Cian",
  "block.minecraft.cyan_concrete": "Coincréit Chian",
  "block.minecraft.cyan_concrete_powder": "Púdar Coincréite Cian",
  "block.minecraft.cyan_glazed_terracotta": "Cré Ghlónraithe Chian",
  "block.minecraft.cyan_shulker_box": "Bosca Shulker Cian",
  "block.minecraft.cyan_stained_glass": "Gloine Chian",
  "block.minecraft.cyan_stained_glass_pane": "Pána Cian",
  "block.minecraft.cyan_terracotta": "Cré Bhruite Chian",
  "block.minecraft.cyan_wool": "Olann Chian",
  "block.minecraft.damaged_anvil": "Inneoin Dhamáistithe",
  "block.minecraft.dandelion": "Caisearbhán",
  "block.minecraft.dark_oak_button": "Cnaipe Darach Duibhe",
  "block.minecraft.dark_oak_door": "Doras Darach Duibhe",
  "block.minecraft.dark_oak_fence": "Claí Darach Duibhe",
  "block.minecraft.dark_oak_fence_gate": "Geata Darach Duibhe",
  "block.minecraft.dark_oak_hanging_sign": "Comhartha Crochta Darach Duibhe",
  "block.minecraft.dark_oak_leaves": "Duilleoga Darach Duibhe",
  "block.minecraft.dark_oak_log": "Bloc Darach Duibhe",
  "block.minecraft.dark_oak_planks": "Cláir Darach Duibhe",
  "block.minecraft.dark_oak_pressure_plate": "Brúphláta Darach Duibhe",
  "block.minecraft.dark_oak_sapling": "Buinneán Darach Duibhe",
  "block.minecraft.dark_oak_shelf": "Seilf Darach Duibhe",
  "block.minecraft.dark_oak_sign": "Comhartha Darach Duibhe",
  "block.minecraft.dark_oak_slab": "Leac Darach Duibhe",
  "block.minecraft.dark_oak_stairs": "Staighre Darach Duibhe",
  "block.minecraft.dark_oak_trapdoor": "Comhla Darach Duibhe",
  "block.minecraft.dark_oak_wall_hanging_sign": "Comhartha Crochta Balla Darach Duibhe",
  "block.minecraft.dark_oak_wall_sign": "Comhartha Balla Darach Duibhe",
  "block.minecraft.dark_oak_wood": "Adhmad Darach Duibhe",
  "block.minecraft.dark_prismarine": "Priosmuirín Dubh",
  "block.minecraft.dark_prismarine_slab": "Leac Priosmuirín Dhuibh",
  "block.minecraft.dark_prismarine_stairs": "Staighre Priosmuirín Dhuibh",
  "block.minecraft.daylight_detector": "Brathadóir Solais Lae",
  "block.minecraft.dead_brain_coral": "Coiréalach Inchinne Marbh",
  "block.minecraft.dead_brain_coral_block": "Bloc Coiréalaigh Inchinne Mhairbh",
  "block.minecraft.dead_brain_coral_fan": "Fean Coiréalaigh Inchinne Mhairbh",
  "block.minecraft.dead_brain_coral_wall_fan": "Fean Balla Coiréalaigh Inchinne Mhairbh",
  "block.minecraft.dead_bubble_coral": "Coiréalach Bolgóideach Marbh",
  "block.minecraft.dead_bubble_coral_block": "Bloc Coiréalaigh Bholgóidigh Mhairbh",
  "block.minecraft.dead_bubble_coral_fan": "Fean Coiréalaigh Bholgóidigh Mhairbh",
  "block.minecraft.dead_bubble_coral_wall_fan": "Fean Balla Coiréalaigh Bholgóidigh Mhairbh",
  "block.minecraft.dead_bush": "Tor Marbh",
  "block.minecraft.dead_fire_coral": "Coiréalach Lasartha Marbh",
  "block.minecraft.dead_fire_coral_block": "Bloc Coiréalaigh Lasartha Mhairbh",
  "block.minecraft.dead_fire_coral_fan": "Fean Coiréalaigh Lasartha Mhairbh",
  "block.minecraft.dead_fire_coral_wall_fan": "Fean Balla Coiréalaigh Lasartha Mhairbh",
  "block.minecraft.dead_horn_coral": "Coiréalach Adharcach Marbh",
  "block.minecraft.dead_horn_coral_block": "Bloc Coiréalaigh Adharcaigh Mhairbh",
  "block.minecraft.dead_horn_coral_fan": "Fean Coiréalaigh Adharcaigh Mhairbh",
  "block.minecraft.dead_horn_coral_wall_fan": "Fean Balla Coiréalaigh Adharcaigh Mhairbh",
  "block.minecraft.dead_tube_coral": "Coiréalach Píopaí Marbh",
  "block.minecraft.dead_tube_coral_block": "Bloc Coiréalaigh Piopaí Mhairbh",
  "block.minecraft.dead_tube_coral_fan": "Fean Coiréalaigh Píopaí Mhairbh",
  "block.minecraft.dead_tube_coral_wall_fan": "Fean Balla Coiréalaigh Píopaí Mhairbh",
  "block.minecraft.decorated_pot": "Pota Maisithe",
  "block.minecraft.deepslate": "Dúshlinn",
  "block.minecraft.deepslate_brick_slab": "Leac Brící Dúshlinne",
  "block.minecraft.deepslate_brick_stairs": "Staighre Brící Dúshlinne",
  "block.minecraft.deepslate_brick_wall": "Balla Brící Dúshlinne",
  "block.minecraft.deepslate_bricks": "Brící Dúshlinne",
  "block.minecraft.deepslate_coal_ore": "Mian Ghuail Dhúshlinne",
  "block.minecraft.deepslate_copper_ore": "Mian Chopair Dhúshlinne",
  "block.minecraft.deepslate_diamond_ore": "Mian Diamaint Dhúshlinne",
  "block.minecraft.deepslate_emerald_ore": "Mian Smaragaide Dhúshlinne",
  "block.minecraft.deepslate_gold_ore": "Mian Óir Dhúshlinne",
  "block.minecraft.deepslate_iron_ore": "Mian Iarainn Dhúshlinne",
  "block.minecraft.deepslate_lapis_ore": "Mian Lapis Lazuli Dhúshlinne",
  "block.minecraft.deepslate_redstone_ore": "Mian Redstone Dhúshlinne",
  "block.minecraft.deepslate_tile_slab": "Leac Leacán Dúshlinne",
  "block.minecraft.deepslate_tile_stairs": "Staighre Leacán Dúshlinne",
  "block.minecraft.deepslate_tile_wall": "Balla Leacán Dúshlinne",
  "block.minecraft.deepslate_tiles": "Leacáin Dúshlinne",
  "block.minecraft.detector_rail": "Ráille Braite",
  "block.minecraft.diamond_block": "Bloc Diamaint",
  "block.minecraft.diamond_ore": "Mian Diamaint",
  "block.minecraft.diorite": "Dióirít",
  "block.minecraft.diorite_slab": "Leac Dhióiríte",
  "block.minecraft.diorite_stairs": "Staighre Dióiríte",
  "block.minecraft.diorite_wall": "Balla Dióiríte",
  "block.minecraft.dirt": "Ithir",
  "block.minecraft.dirt_path": "Cosán Ithreach",
  "block.minecraft.dispenser": "Teilgeoir",
  "block.minecraft.dragon_egg": "Ubh Dhragain",
  "block.minecraft.dragon_head": "Ceann Dragain",
  "block.minecraft.dragon_wall_head": "Ceann Balla Dragain",
  "block.minecraft.dried_ghast": "Ghast Triomaithe",
  "block.minecraft.dried_kelp_block": "Bloc Ceilpe Triomaithe",
  "block.minecraft.dripstone_block": "Bloc Cloiche Sileáin",
  "block.minecraft.dropper": "Dáileoir",
  "block.minecraft.emerald_block": "Bloc Smaragaide",
  "block.minecraft.emerald_ore": "Mian Smaragaide",
  "block.minecraft.enchanting_table": "Bord Asarlaíochta",
  "block.minecraft.end_gateway": "Geata End",
  "block.minecraft.end_portal": "Tairseach an End",
  "block.minecraft.end_portal_frame": "Fráma Thairseach an End",
  "block.minecraft.end_rod": "Slat End",
  "block.minecraft.end_stone": "Cloch End",
  "block.minecraft.end_stone_brick_slab": "Leac Brící Cloiche End",
  "block.minecraft.end_stone_brick_stairs": "Staighre Brící Cloiche End",
  "block.minecraft.end_stone_brick_wall": "Balla Brící Cloiche End",
  "block.minecraft.end_stone_bricks": "Brící Cloiche End",
  "block.minecraft.ender_chest": "Cófra Ender",
  "block.minecraft.exposed_chiseled_copper": "Copar Siséalta Nochta",
  "block.minecraft.exposed_copper": "Copar Nochta",
  "block.minecraft.exposed_copper_bars": "Barraí Copair Nochta",
  "block.minecraft.exposed_copper_bulb": "Bolgán Copair Nochta",
  "block.minecraft.exposed_copper_chain": "Slabhra Copair Nochta",
  "block.minecraft.exposed_copper_chest": "Cófra Copair Nochta",
  "block.minecraft.exposed_copper_door": "Doras Copair Nochta",
  "block.minecraft.exposed_copper_golem_statue": "Dealbh de Ghólam Copair Nochta",
  "block.minecraft.exposed_copper_grate": "Gráta Copair Nochta",
  "block.minecraft.exposed_copper_lantern": "Laindéar Copair Nochta",
  "block.minecraft.exposed_copper_trapdoor": "Comhla Copair Nochta",
  "block.minecraft.exposed_cut_copper": "Copar Gearrtha Nochta",
  "block.minecraft.exposed_cut_copper_slab": "Leac Copair Ghearrtha Nochta",
  "block.minecraft.exposed_cut_copper_stairs": "Staighre Copair Ghearrtha Nochta",
  "block.minecraft.exposed_lightning_rod": "Slat Tintrí Nochta",
  "block.minecraft.farmland": "Talamh Feirme",
  "block.minecraft.fern": "Raithneach",
  "block.minecraft.fire": "Tine",
  "block.minecraft.fire_coral": "Coiréalach Lasartha",
  "block.minecraft.fire_coral_block": "Bloc Coiréalaigh Lasartha",
  "block.minecraft.fire_coral_fan": "Fean Coiréalaigh Lasartha",
  "block.minecraft.fire_coral_wall_fan": "Fean Balla Coiréalaigh Lasartha",
  "block.minecraft.firefly_bush": "Tom na Lampróg",
  "block.minecraft.fletching_table": "Bord Saighead",
  "block.minecraft.flower_pot": "Pota Bláthanna",
  "block.minecraft.flowering_azalea": "Asáilia faoi Bhláth",
  "block.minecraft.flowering_azalea_leaves": "Duilleoga Asáilia faoi Bhláth",
  "block.minecraft.frogspawn": "Sceathrach Froig",
  "block.minecraft.frosted_ice": "Oighear Scamallach",
  "block.minecraft.furnace": "Foirnéis",
  "block.minecraft.gilded_blackstone": "Dúchloch Óraithe",
  "block.minecraft.glass": "Gloine",
  "block.minecraft.glass_pane": "Pána",
  "block.minecraft.glow_lichen": "Léicean Lonrach",
  "block.minecraft.glowstone": "Loinrít",
  "block.minecraft.gold_block": "Bloc Óir",
  "block.minecraft.gold_ore": "Mian Óir",
  "block.minecraft.golden_dandelion": "Caisearbhán Óir",
  "block.minecraft.granite": "Eibhear",
  "block.minecraft.granite_slab": "Leac Eibhir",
  "block.minecraft.granite_stairs": "Staighre Eibhir",
  "block.minecraft.granite_wall": "Balla Eibhir",
  "block.minecraft.grass": "Féar",
  "block.minecraft.grass_block": "Bloc Féir",
  "block.minecraft.gravel": "Gairbhéal",
  "block.minecraft.gray_banner": "Meirge Liath",
  "block.minecraft.gray_bed": "Leaba Liath",
  "block.minecraft.gray_candle": "Coinneal Liath",
  "block.minecraft.gray_candle_cake": "Cáca le Coinneal Liath",
  "block.minecraft.gray_carpet": "Cairpéad Liath",
  "block.minecraft.gray_concrete": "Coincréit Liath",
  "block.minecraft.gray_concrete_powder": "Púdar Coincréite Liath",
  "block.minecraft.gray_glazed_terracotta": "Cré Ghlónraithe Liath",
  "block.minecraft.gray_shulker_box": "Bosca Shulker Liath",
  "block.minecraft.gray_stained_glass": "Gloine Liath",
  "block.minecraft.gray_stained_glass_pane": "Pána Liath",
  "block.minecraft.gray_terracotta": "Cré Bhruite Liath",
  "block.minecraft.gray_wool": "Olann Liath",
  "block.minecraft.green_banner": "Meirge Uaine",
  "block.minecraft.green_bed": "Leaba Uaine",
  "block.minecraft.green_candle": "Coinneal Uaine",
  "block.minecraft.green_candle_cake": "Cáca le Coinneal Uaine",
  "block.minecraft.green_carpet": "Cairpéad Uaine",
  "block.minecraft.green_concrete": "Coincréit Uaine",
  "block.minecraft.green_concrete_powder": "Púdar Coincréite Uaine",
  "block.minecraft.green_glazed_terracotta": "Cré Ghlónraithe Uaine",
  "block.minecraft.green_shulker_box": "Bosca Shulker Uaine",
  "block.minecraft.green_stained_glass": "Gloine Uaine",
  "block.minecraft.green_stained_glass_pane": "Pána Uaine",
  "block.minecraft.green_terracotta": "Cré Bhruite Uaine",
  "block.minecraft.green_wool": "Olann Uaine",
  "block.minecraft.grindstone": "Cloch Fhaobhair",
  "block.minecraft.hanging_roots": "Fréamhach Crochta",
  "block.minecraft.hay_block": "Burla Féir",
  "block.minecraft.heavy_core": "Croí Trom",
  "block.minecraft.heavy_weighted_pressure_plate": "Brúphláta Trom",
  "block.minecraft.honey_block": "Bloc Meala",
  "block.minecraft.honeycomb_block": "Bloc Milteoige",
  "block.minecraft.hopper": "Crannóg",
  "block.minecraft.horn_coral": "Coiréalach Adharcach",
  "block.minecraft.horn_coral_block": "Bloic Coiréalaigh Adharcaigh",
  "block.minecraft.horn_coral_fan": "Fean Coiréalaigh Adharcaigh",
  "block.minecraft.horn_coral_wall_fan": "Fean Balla Coiréalaigh Adharcaigh",
  "block.minecraft.ice": "Oighear",
  "block.minecraft.infested_chiseled_stone_bricks": "Brící Cloiche Siséalta Foirgthe",
  "block.minecraft.infested_cobblestone": "Doirneog Fhoirgthe",
  "block.minecraft.infested_cracked_stone_bricks": "Brící Cloiche Scoilte Foirgthe",
  "block.minecraft.infested_deepslate": "Dúshlinn Fhoirgthe",
  "block.minecraft.infested_mossy_stone_bricks": "Brící Cloiche Caonaigh Foirgthe",
  "block.minecraft.infested_stone": "Cloch Fhoirgthe",
  "block.minecraft.infested_stone_bricks": "Brící Cloiche Foirgthe",
  "block.minecraft.iron_bars": "Barraí Iarainn",
  "block.minecraft.iron_block": "Bloc Iarainn",
  "block.minecraft.iron_chain": "Slabhra Iarainn",
  "block.minecraft.iron_door": "Doras Iarainn",
  "block.minecraft.iron_ore": "Mian Iarainn",
  "block.minecraft.iron_trapdoor": "Comhla Iarainn",
  "block.minecraft.jack_o_lantern": "Seán na Gealaí",
  "block.minecraft.jigsaw": "Bloc Míreanna Mearaí",
  "block.minecraft.jukebox": "Júcbhosca",
  "block.minecraft.jungle_button": "Cnaipe Dufaire",
  "block.minecraft.jungle_door": "Doras Dufaire",
  "block.minecraft.jungle_fence": "Claí Dufaire",
  "block.minecraft.jungle_fence_gate": "Geata Dufaire",
  "block.minecraft.jungle_hanging_sign": "Comhartha Crochta Dufaire",
  "block.minecraft.jungle_leaves": "Duilleoga Dufaire",
  "block.minecraft.jungle_log": "Bloc Dufaire",
  "block.minecraft.jungle_planks": "Cláir Dufaire",
  "block.minecraft.jungle_pressure_plate": "Brúphláta Dufaire",
  "block.minecraft.jungle_sapling": "Buinneán Dufaire",
  "block.minecraft.jungle_shelf": "Seilf Dhufair",
  "block.minecraft.jungle_sign": "Comhartha Dufaire",
  "block.minecraft.jungle_slab": "Leac Dhufaire",
  "block.minecraft.jungle_stairs": "Staighre Dufaire",
  "block.minecraft.jungle_trapdoor": "Comhla Dhufaire",
  "block.minecraft.jungle_wall_hanging_sign": "Comhartha Crochta Balla Dufaire",
  "block.minecraft.jungle_wall_sign": "Comhartha Balla Dufaire",
  "block.minecraft.jungle_wood": "Adhmad Dufaire",
  "block.minecraft.kelp": "Ceilp",
  "block.minecraft.kelp_plant": "Planda Ceilpe",
  "block.minecraft.ladder": "Dréimire",
  "block.minecraft.lantern": "Laindéar",
  "block.minecraft.lapis_block": "Bloc Lapis Lazuli",
  "block.minecraft.lapis_ore": "Mian Lapis Lazuli",
  "block.minecraft.large_amethyst_bud": "Bachlóg Mhór Aimitise",
  "block.minecraft.large_fern": "Raithneach Mhór",
  "block.minecraft.lava": "Laibhe",
  "block.minecraft.lava_cauldron": "Coire Laibhe",
  "block.minecraft.leaf_litter": "Easair Duillí",
  "block.minecraft.lectern": "Léachtán",
  "block.minecraft.lever": "Luamhán",
  "block.minecraft.light": "Solas",
  "block.minecraft.light_blue_banner": "Meirge Bánghorm",
  "block.minecraft.light_blue_bed": "Leaba Bhánghorm",
  "block.minecraft.light_blue_candle": "Coinneal Bhánghorm",
  "block.minecraft.light_blue_candle_cake": "Cáca le Coinneal Bhánghorm",
  "block.minecraft.light_blue_carpet": "Cairpéad Bánghorm",
  "block.minecraft.light_blue_concrete": "Coincréit Bhánghorm",
  "block.minecraft.light_blue_concrete_powder": "Púdar Coincréite Bánghorm",
  "block.minecraft.light_blue_glazed_terracotta": "Cré Ghlónraithe Bhánghorm",
  "block.minecraft.light_blue_shulker_box": "Bosca Shulker Bánghorm",
  "block.minecraft.light_blue_stained_glass": "Gloine Bhánghorm",
  "block.minecraft.light_blue_stained_glass_pane": "Pána Bánghorm",
  "block.minecraft.light_blue_terracotta": "Cré Bhruite Bhánghorm",
  "block.minecraft.light_blue_wool": "Olann Bhánghorm",
  "block.minecraft.light_gray_banner": "Meirge Fionnliath",
  "block.minecraft.light_gray_bed": "Leaba Fhionnliath",
  "block.minecraft.light_gray_candle": "Coinneal Fhionnliath",
  "block.minecraft.light_gray_candle_cake": "Cáca le Coinneal Fhionnliath",
  "block.minecraft.light_gray_carpet": "Cairpéad Fionnliath",
  "block.minecraft.light_gray_concrete": "Coincréit Fhionnliath",
  "block.minecraft.light_gray_concrete_powder": "Púdar Coincréite Fionnliath",
  "block.minecraft.light_gray_glazed_terracotta": "Cré Ghlónraithe Fhionnliath",
  "block.minecraft.light_gray_shulker_box": "Bosca Shulker Fionnliath",
  "block.minecraft.light_gray_stained_glass": "Gloine Fhionnliath",
  "block.minecraft.light_gray_stained_glass_pane": "Pána Fionnliath",
  "block.minecraft.light_gray_terracotta": "Cré Bhruite Fhionnliath",
  "block.minecraft.light_gray_wool": "Olann Fhionnliath",
  "block.minecraft.light_weighted_pressure_plate": "Brúphláta Éadrom",
  "block.minecraft.lightning_rod": "Slat Tintrí",
  "block.minecraft.lilac": "Líológ",
  "block.minecraft.lily_of_the_valley": "Lile na nGleanntán",
  "block.minecraft.lily_pad": "Duilleog Bháite",
  "block.minecraft.lime_banner": "Meirge Glasuaine",
  "block.minecraft.lime_bed": "Leaba Ghlasuaine",
  "block.minecraft.lime_candle": "Coinneal Ghlasuaine",
  "block.minecraft.lime_candle_cake": "Cáca le Coinneal Ghlasuaine",
  "block.minecraft.lime_carpet": "Cairpéad Glasuaine",
  "block.minecraft.lime_concrete": "Coincréit Ghlasuaine",
  "block.minecraft.lime_concrete_powder": "Púdar Coincréite Glasuaine",
  "block.minecraft.lime_glazed_terracotta": "Cré Ghlónraithe Ghlasuaine",
  "block.minecraft.lime_shulker_box": "Bosca Shulker Glasuaine",
  "block.minecraft.lime_stained_glass": "Gloine Ghlasuaine",
  "block.minecraft.lime_stained_glass_pane": "Pána Glasuaine",
  "block.minecraft.lime_terracotta": "Cré Bhruite Ghlasuaine",
  "block.minecraft.lime_wool": "Olann Ghlasuaine",
  "block.minecraft.lodestone": "Adhmaint",
  "block.minecraft.loom": "Seol",
  "block.minecraft.magenta_banner": "Meirge Maigeanta",
  "block.minecraft.magenta_bed": "Leaba Mhaigeanta",
  "block.minecraft.magenta_candle": "Coinneal Mhaigeanta",
  "block.minecraft.magenta_candle_cake": "Cáca le Coinneal Mhaigeanta",
  "block.minecraft.magenta_carpet": "Cairpéad Maigeanta",
  "block.minecraft.magenta_concrete": "Coincréit Mhaigeanta",
  "block.minecraft.magenta_concrete_powder": "Púdar Coincréite Maigeanta",
  "block.minecraft.magenta_glazed_terracotta": "Cré Ghlónraithe Mhaigeanta",
  "block.minecraft.magenta_shulker_box": "Bosca Shulker Maigeanta",
  "block.minecraft.magenta_stained_glass": "Gloine Mhaigeanta",
  "block.minecraft.magenta_stained_glass_pane": "Pána Maigeanta",
  "block.minecraft.magenta_terracotta": "Cré Bhruite Mhaigeanta",
  "block.minecraft.magenta_wool": "Olann Mhaigeanta",
  "block.minecraft.magma_block": "Bloc Magma",
  "block.minecraft.mangrove_button": "Cnaipe Mangróibh",
  "block.minecraft.mangrove_door": "Doras Mangróibh",
  "block.minecraft.mangrove_fence": "Claí Mangróibh",
  "block.minecraft.mangrove_fence_gate": "Geata Mangróibh",
  "block.minecraft.mangrove_hanging_sign": "Comhartha Crochta Mangróibh",
  "block.minecraft.mangrove_leaves": "Duilleoga Mangróibh",
  "block.minecraft.mangrove_log": "Bloc Mangróibh",
  "block.minecraft.mangrove_planks": "Cláir Mhangróibh",
  "block.minecraft.mangrove_pressure_plate": "Brúphláta Mangróibh",
  "block.minecraft.mangrove_propagule": "Buinneán Mangróibh",
  "block.minecraft.mangrove_roots": "Fréamhach Mangróibh",
  "block.minecraft.mangrove_shelf": "Seilf Mhangróibh",
  "block.minecraft.mangrove_sign": "Comhartha Mangróibh",
  "block.minecraft.mangrove_slab": "Leac Mhangróibh",
  "block.minecraft.mangrove_stairs": "Staighre Mangróibh",
  "block.minecraft.mangrove_trapdoor": "Comhla Mhangróibh",
  "block.minecraft.mangrove_wall_hanging_sign": "Comhartha Crochta Balla Mangróibh",
  "block.minecraft.mangrove_wall_sign": "Comhartha Balla Mangróibh",
  "block.minecraft.mangrove_wood": "Adhmad Mangróibh",
  "block.minecraft.medium_amethyst_bud": "Bachlóg Mheánach Aimitise",
  "block.minecraft.melon": "Mealbhacán",
  "block.minecraft.melon_stem": "Gas Mealbhacáin",
  "block.minecraft.moss_block": "Bloc Caonaigh",
  "block.minecraft.moss_carpet": "Cairpéad Caonaigh",
  "block.minecraft.mossy_cobblestone": "Doirneog Chaonaigh",
  "block.minecraft.mossy_cobblestone_slab": "Leac Doirneoige Caonaigh",
  "block.minecraft.mossy_cobblestone_stairs": "Staighre Doirneoige Caonaigh",
  "block.minecraft.mossy_cobblestone_wall": "Balla Doirneoige Caonaigh",
  "block.minecraft.mossy_stone_brick_slab": "Leac Brící Cloiche Caonaigh",
  "block.minecraft.mossy_stone_brick_stairs": "Staighre Brící Cloiche Caonaigh",
  "block.minecraft.mossy_stone_brick_wall": "Balla Brící Cloiche Caonaigh",
  "block.minecraft.mossy_stone_bricks": "Brící Cloiche Caonaigh",
  "block.minecraft.moving_piston": "Loine Ghluaiste",
  "block.minecraft.mud": "Láib",
  "block.minecraft.mud_brick_slab": "Leac Brící Dóibe",
  "block.minecraft.mud_brick_stairs": "Staighre Brící Dóibe",
  "block.minecraft.mud_brick_wall": "Balla Brící Dóibe",
  "block.minecraft.mud_bricks": "Brící Dóibe",
  "block.minecraft.muddy_mangrove_roots": "Fréamhach Mangróibh Lábach",
  "block.minecraft.mushroom_stem": "Gas Beacáin",
  "block.minecraft.mycelium": "Mícéiliam",
  "block.minecraft.nether_brick_fence": "Claí Brící Nether",
  "block.minecraft.nether_brick_slab": "Leac Brící Nether",
  "block.minecraft.nether_brick_stairs": "Staighre Brící Nether",
  "block.minecraft.nether_brick_wall": "Balla Brící Nether",
  "block.minecraft.nether_bricks": "Brící Nether",
  "block.minecraft.nether_gold_ore": "Mian Óir Nether",
  "block.minecraft.nether_portal": "Tairseach an Nether",
  "block.minecraft.nether_quartz_ore": "Mian Grianchloiche Nether",
  "block.minecraft.nether_sprouts": "Bachlóga Nether",
  "block.minecraft.nether_wart": "Lus an Nether",
  "block.minecraft.nether_wart_block": "Bloc Lusa Nether",
  "block.minecraft.netherite_block": "Bloc Netheríte",
  "block.minecraft.netherrack": "Netherrack",
  "block.minecraft.note_block": "Bloc Nóta",
  "block.minecraft.oak_button": "Cnaipe Darach",
  "block.minecraft.oak_door": "Doras Darach",
  "block.minecraft.oak_fence": "Claí Darach",
  "block.minecraft.oak_fence_gate": "Geata Darach",
  "block.minecraft.oak_hanging_sign": "Comhartha Crochta Darach",
  "block.minecraft.oak_leaves": "Duilleoga Darach",
  "block.minecraft.oak_log": "Bloc Darach",
  "block.minecraft.oak_planks": "Cláir Dharach",
  "block.minecraft.oak_pressure_plate": "Brúphláta Darach",
  "block.minecraft.oak_sapling": "Buinneán Darach",
  "block.minecraft.oak_shelf": "Seilf Dharach",
  "block.minecraft.oak_sign": "Comhartha Darach",
  "block.minecraft.oak_slab": "Leac Dharach",
  "block.minecraft.oak_stairs": "Staighre Darach",
  "block.minecraft.oak_trapdoor": "Comhla Dharach",
  "block.minecraft.oak_wall_hanging_sign": "Comhartha Crochta Balla Darach",
  "block.minecraft.oak_wall_sign": "Comhartha Balla Darach",
  "block.minecraft.oak_wood": "Adhmad Darach",
  "block.minecraft.observer": "Breathnóir",
  "block.minecraft.obsidian": "Obsaidian",
  "block.minecraft.ochre_froglight": "Frogsholas Ócair",
  "block.minecraft.ominous_banner": "Meirge Tuarúil",
  "block.minecraft.open_eyeblossom": "Bláth na Súl Oscailte",
  "block.minecraft.orange_banner": "Meirge Oráiste",
  "block.minecraft.orange_bed": "Leaba Oráiste",
  "block.minecraft.orange_candle": "Coinneal Oráiste",
  "block.minecraft.orange_candle_cake": "Cáca le Coinneal Oráiste",
  "block.minecraft.orange_carpet": "Cairpéad Oráiste",
  "block.minecraft.orange_concrete": "Coincréit Oráiste",
  "block.minecraft.orange_concrete_powder": "Púdar Coincréite Oráiste",
  "block.minecraft.orange_glazed_terracotta": "Cré Ghlónraithe Oráiste",
  "block.minecraft.orange_shulker_box": "Bosca Shulker Oráiste",
  "block.minecraft.orange_stained_glass": "Gloine Oráiste",
  "block.minecraft.orange_stained_glass_pane": "Pána Oráiste",
  "block.minecraft.orange_terracotta": "Cré Bhruite Oráiste",
  "block.minecraft.orange_tulip": "Tiúilip Oráiste",
  "block.minecraft.orange_wool": "Olann Oráiste",
  "block.minecraft.oxeye_daisy": "Nóinín Mór",
  "block.minecraft.oxidized_chiseled_copper": "Copar Siséalta Ocsaídithe",
  "block.minecraft.oxidized_copper": "Copar Ocsaídithe",
  "block.minecraft.oxidized_copper_bars": "Barraí Copair Ocsaídithe",
  "block.minecraft.oxidized_copper_bulb": "Bolgán Copair Ocsaídithe",
  "block.minecraft.oxidized_copper_chain": "Slabhra Copair Ocsaídithe",
  "block.minecraft.oxidized_copper_chest": "Cófra Copair Ocsaídithe",
  "block.minecraft.oxidized_copper_door": "Doras Copair Ocsaídithe",
  "block.minecraft.oxidized_copper_golem_statue": "Dealbh de Ghólam Copair Ocsaídithe",
  "block.minecraft.oxidized_copper_grate": "Gráta Copair Ocsaídithe",
  "block.minecraft.oxidized_copper_lantern": "Laindéar Copair Ocsaídithe",
  "block.minecraft.oxidized_copper_trapdoor": "Comhla Copair Ocsaídithe",
  "block.minecraft.oxidized_cut_copper": "Copar Gearrtha Ocsaídithe",
  "block.minecraft.oxidized_cut_copper_slab": "Leac Copair Ghearrtha Ocsaídithe",
  "block.minecraft.oxidized_cut_copper_stairs": "Staighre Copair Ghearrtha Ocsaídithe",
  "block.minecraft.oxidized_lightning_rod": "Slat Tintrí Ocsaídithe",
  "block.minecraft.packed_ice": "Oighear Pacáilte",
  "block.minecraft.packed_mud": "Dóib",
  "block.minecraft.pale_hanging_moss": "Caonach Crochta Geal",
  "block.minecraft.pale_moss_block": "Bloc Caonaigh Ghil",
  "block.minecraft.pale_moss_carpet": "Cairpéad Caonaigh Ghil",
  "block.minecraft.pale_oak_button": "Cnaipe Darach Gile",
  "block.minecraft.pale_oak_door": "Doras Darach Gile",
  "block.minecraft.pale_oak_fence": "Claí Darach Gile",
  "block.minecraft.pale_oak_fence_gate": "Geata Darach Gile",
  "block.minecraft.pale_oak_hanging_sign": "Comhartha Crochta Darach Gile",
  "block.minecraft.pale_oak_leaves": "Duilleoga Darach Gile",
  "block.minecraft.pale_oak_log": "Bloc Darach Gile",
  "block.minecraft.pale_oak_planks": "Cláir Darach Gile",
  "block.minecraft.pale_oak_pressure_plate": "Brúphláta Darach Gile",
  "block.minecraft.pale_oak_sapling": "Buinneán Darach Gile",
  "block.minecraft.pale_oak_shelf": "Seilf Darach Gile",
  "block.minecraft.pale_oak_sign": "Comhartha Darach Gile",
  "block.minecraft.pale_oak_slab": "Leac Darach Gile",
  "block.minecraft.pale_oak_stairs": "Staighre Darach Gile",
  "block.minecraft.pale_oak_trapdoor": "Comhla Darach Gile",
  "block.minecraft.pale_oak_wall_hanging_sign": "Comhartha Crochta Balla Darach Gile",
  "block.minecraft.pale_oak_wall_sign": "Comhartha Balla Darach Gile",
  "block.minecraft.pale_oak_wood": "Adhmad Darach Gile",
  "block.minecraft.pearlescent_froglight": "Frogsholas Péarlach",
  "block.minecraft.peony": "Piaine",
  "block.minecraft.petrified_oak_slab": "Leac Darach Clochraithe",
  "block.minecraft.piglin_head": "Ceann Piglin",
  "block.minecraft.piglin_wall_head": "Ceann Balla Piglin",
  "block.minecraft.pink_banner": "Meirge Bándearg",
  "block.minecraft.pink_bed": "Leaba Bhándearg",
  "block.minecraft.pink_candle": "Coinneal Bhándearg",
  "block.minecraft.pink_candle_cake": "Cáca le Coinneal Bhándearg",
  "block.minecraft.pink_carpet": "Cairpéad Bándearg",
  "block.minecraft.pink_concrete": "Coincréit Bhándearg",
  "block.minecraft.pink_concrete_powder": "Púdar Coincréite Bándearg",
  "block.minecraft.pink_glazed_terracotta": "Cré Ghlónraithe Bhándearg",
  "block.minecraft.pink_petals": "Peitil Bhándearga",
  "block.minecraft.pink_shulker_box": "Bosca Shulker Bándearg",
  "block.minecraft.pink_stained_glass": "Gloine Bhándearg",
  "block.minecraft.pink_stained_glass_pane": "Pána Bándearg",
  "block.minecraft.pink_terracotta": "Cré Bhruite Bhándearg",
  "block.minecraft.pink_tulip": "Tiúilip Bhándearg",
  "block.minecraft.pink_wool": "Olann Bhándearg",
  "block.minecraft.piston": "Loine",
  "block.minecraft.piston_head": "Ceann Loine",
  "block.minecraft.pitcher_crop": "Barr Ascaide",
  "block.minecraft.pitcher_plant": "Ascaid",
  "block.minecraft.player_head": "Ceann Imreora",
  "block.minecraft.player_head.named": "Ceann %s",
  "block.minecraft.player_wall_head": "Ceann Balla Imreora",
  "block.minecraft.podzol": "Podsal",
  "block.minecraft.pointed_dripstone": "Cloch Shileáin Rinneach",
  "block.minecraft.polished_andesite": "Aindéisít Shnasta",
  "block.minecraft.polished_andesite_slab": "Leac Aindéisíte Snasta",
  "block.minecraft.polished_andesite_stairs": "Staighre Andéisíte Snasta",
  "block.minecraft.polished_basalt": "Basalt Snasta",
  "block.minecraft.polished_blackstone": "Dúchloch Shnasta",
  "block.minecraft.polished_blackstone_brick_slab": "Leac Brící Dúchloiche Snasta",
  "block.minecraft.polished_blackstone_brick_stairs": "Staighre Brící Dúchloiche Snasta",
  "block.minecraft.polished_blackstone_brick_wall": "Balla Brící Dúchloiche Snasta",
  "block.minecraft.polished_blackstone_bricks": "Brící Dúchloiche Snasta",
  "block.minecraft.polished_blackstone_button": "Cnaipe Dúchloiche Snasta",
  "block.minecraft.polished_blackstone_pressure_plate": "Brúphláta Dúchloiche Snasta",
  "block.minecraft.polished_blackstone_slab": "Leac Dúchloiche Snasta",
  "block.minecraft.polished_blackstone_stairs": "Staighre Dúchloiche Snasta",
  "block.minecraft.polished_blackstone_wall": "Balla Dúchloiche Snasta",
  "block.minecraft.polished_deepslate": "Dúshlinn Shnasta",
  "block.minecraft.polished_deepslate_slab": "Leac Dúshlinne Snasta",
  "block.minecraft.polished_deepslate_stairs": "Staighre Dúshlinne Snasta",
  "block.minecraft.polished_deepslate_wall": "Balla Dúshlinne Snasta",
  "block.minecraft.polished_diorite": "Dióirít Shnasta",
  "block.minecraft.polished_diorite_slab": "Leac Dióiríte Snasta",
  "block.minecraft.polished_diorite_stairs": "Staighre Dióiríte Snasta",
  "block.minecraft.polished_granite": "Eibhear Snasta",
  "block.minecraft.polished_granite_slab": "Leac Eibhir Shnasta",
  "block.minecraft.polished_granite_stairs": "Staighre Eibhir Shnasta",
  "block.minecraft.polished_tuff": "Tuf Snasta",
  "block.minecraft.polished_tuff_slab": "Leac Tuf Snasta",
  "block.minecraft.polished_tuff_stairs": "Staighre Tuf Snasta",
  "block.minecraft.polished_tuff_wall": "Balla Tuf Snasta",
  "block.minecraft.poppy": "Poipín",
  "block.minecraft.potatoes": "Prátaí",
  "block.minecraft.potted_acacia_sapling": "Buinneán Acáise i bPota",
  "block.minecraft.potted_allium": "Allium i bPota",
  "block.minecraft.potted_azalea_bush": "Asáilia i bPota",
  "block.minecraft.potted_azure_bluet": "Goirmín Spéiriúil i bPota",
  "block.minecraft.potted_bamboo": "Bambú i bPota",
  "block.minecraft.potted_birch_sapling": "Buinneán Beithe i bPota",
  "block.minecraft.potted_blue_orchid": "Magairlín Gorm i bPota",
  "block.minecraft.potted_brown_mushroom": "Beacán Donn i bPota",
  "block.minecraft.potted_cactus": "Cachtas i bPota",
  "block.minecraft.potted_cherry_sapling": "Buinneán Silín i bPota",
  "block.minecraft.potted_closed_eyeblossom": "Bláth na Súl Dúnta i bPota",
  "block.minecraft.potted_cornflower": "Gormán i bPota",
  "block.minecraft.potted_crimson_fungus": "Fungas Craorag i bPota",
  "block.minecraft.potted_crimson_roots": "Fréamhach Craorag i bPota",
  "block.minecraft.potted_dandelion": "Caisearbhán i bPota",
  "block.minecraft.potted_dark_oak_sapling": "Buinneán Darach Duibhe i bPota",
  "block.minecraft.potted_dead_bush": "Tor Marbh i bPota",
  "block.minecraft.potted_fern": "Raithneach i bPota",
  "block.minecraft.potted_flowering_azalea_bush": "Asáilia faoi Bhláth i bPota",
  "block.minecraft.potted_golden_dandelion": "Caisearbhán Óir i bPota",
  "block.minecraft.potted_jungle_sapling": "Buinneán Dufaire i bPota",
  "block.minecraft.potted_lily_of_the_valley": "Lile na nGleanntán i bPota",
  "block.minecraft.potted_mangrove_propagule": "Buinneán Mangróibh i bPota",
  "block.minecraft.potted_oak_sapling": "Buinneán Darach i bPota",
  "block.minecraft.potted_open_eyeblossom": "Bláth na Súl Oscailte i bPota",
  "block.minecraft.potted_orange_tulip": "Tiúilip Oráiste i bPota",
  "block.minecraft.potted_oxeye_daisy": "Nóinín Mór i bPota",
  "block.minecraft.potted_pale_oak_sapling": "Buinneán Darach Gile i bPota",
  "block.minecraft.potted_pink_tulip": "Tiúilip Bhándhearg i bPota",
  "block.minecraft.potted_poppy": "Poipín i bPota",
  "block.minecraft.potted_red_mushroom": "Beacán Dearg i bPota",
  "block.minecraft.potted_red_tulip": "Tiúilip Dhearg i bPota",
  "block.minecraft.potted_spruce_sapling": "Buinneán Sprúis i bPota",
  "block.minecraft.potted_torchflower": "Bláth Tóirse i bPota",
  "block.minecraft.potted_warped_fungus": "Fungas Saofa i bPota",
  "block.minecraft.potted_warped_roots": "Fréamhach Saofa i bPota",
  "block.minecraft.potted_white_tulip": "Tiúilip Bhán i bPota",
  "block.minecraft.potted_wither_rose": "Rós Wither i bPota",
  "block.minecraft.powder_snow": "Púdar Sneachta",
  "block.minecraft.powder_snow_cauldron": "Coire Púdair Shneachta",
  "block.minecraft.powered_rail": "Ráille Cumhachta",
  "block.minecraft.prismarine": "Priosmuirín",
  "block.minecraft.prismarine_brick_slab": "Leac Brící Priosmuirín",
  "block.minecraft.prismarine_brick_stairs": "Staighre Brící Priosmuirín",
  "block.minecraft.prismarine_bricks": "Brící Priosmuirín",
  "block.minecraft.prismarine_slab": "Leac Phriosmuirín",
  "block.minecraft.prismarine_stairs": "Staighre Priosmuirín",
  "block.minecraft.prismarine_wall": "Balla Priosmuirín",
  "block.minecraft.pumpkin": "Puimcín",
  "block.minecraft.pumpkin_stem": "Gas Puimcín",
  "block.minecraft.purple_banner": "Meirge Corcra",
  "block.minecraft.purple_bed": "Leaba Chorcra",
  "block.minecraft.purple_candle": "Coinneal Chorcra",
  "block.minecraft.purple_candle_cake": "Cáca le Coinneal Chorcra",
  "block.minecraft.purple_carpet": "Cairpéad Corcra",
  "block.minecraft.purple_concrete": "Coincréit Chorcra",
  "block.minecraft.purple_concrete_powder": "Púdar Coincréite Corcra",
  "block.minecraft.purple_glazed_terracotta": "Cré Ghlónraithe Chorcra",
  "block.minecraft.purple_shulker_box": "Bosca Shulker Corcra",
  "block.minecraft.purple_stained_glass": "Gloine Chorcra",
  "block.minecraft.purple_stained_glass_pane": "Pána Corcra",
  "block.minecraft.purple_terracotta": "Cré Bhruite Chorcra",
  "block.minecraft.purple_wool": "Olann Chorcra",
  "block.minecraft.purpur_block": "Bloc Purpur",
  "block.minecraft.purpur_pillar": "Colún Purpur",
  "block.minecraft.purpur_slab": "Leac Purpur",
  "block.minecraft.purpur_stairs": "Staighre Purpur",
  "block.minecraft.quartz_block": "Bloc Grianchloiche",
  "block.minecraft.quartz_bricks": "Brící Grianchloiche",
  "block.minecraft.quartz_pillar": "Colún Grianchloiche",
  "block.minecraft.quartz_slab": "Leac Ghrianchloiche",
  "block.minecraft.quartz_stairs": "Staighre Grianchloiche",
  "block.minecraft.rail": "Ráille",
  "block.minecraft.raw_copper_block": "Bloc Copair Amh",
  "block.minecraft.raw_gold_block": "Bloc Óir Amh",
  "block.minecraft.raw_iron_block": "Bloc Amhiarainn",
  "block.minecraft.red_banner": "Meirge Dearg",
  "block.minecraft.red_bed": "Leaba Dhearg",
  "block.minecraft.red_candle": "Coinneal Dhearg",
  "block.minecraft.red_candle_cake": "Cáca le Coinneal Dhearg",
  "block.minecraft.red_carpet": "Cairpéad Dearg",
  "block.minecraft.red_concrete": "Coincréit Dhearg",
  "block.minecraft.red_concrete_powder": "Púdar Coincréite Dearg",
  "block.minecraft.red_glazed_terracotta": "Cré Ghlónraithe Dhearg",
  "block.minecraft.red_mushroom": "Beacán Dearg",
  "block.minecraft.red_mushroom_block": "Bloc Beacáin Dheirg",
  "block.minecraft.red_nether_brick_slab": "Leac Brící Nether Dearga",
  "block.minecraft.red_nether_brick_stairs": "Staighre Brící Nether Dearga",
  "block.minecraft.red_nether_brick_wall": "Balla Brící Nether Dearga",
  "block.minecraft.red_nether_bricks": "Brící Nether Dearga",
  "block.minecraft.red_sand": "Gaineamh Rua",
  "block.minecraft.red_sandstone": "Gaineamhchloch Rua",
  "block.minecraft.red_sandstone_slab": "Leac Gaineamhchloiche Rua",
  "block.minecraft.red_sandstone_stairs": "Staighre Gaineamhchloiche Rua",
  "block.minecraft.red_sandstone_wall": "Balla Gaineamhchloiche Rua",
  "block.minecraft.red_shulker_box": "Bosca Shulker Dearg",
  "block.minecraft.red_stained_glass": "Gloine Dhearg",
  "block.minecraft.red_stained_glass_pane": "Pána Dearg",
  "block.minecraft.red_terracotta": "Cré Bhruite Dhearg",
  "block.minecraft.red_tulip": "Tiúilip Dhearg",
  "block.minecraft.red_wool": "Olann Dhearg",
  "block.minecraft.redstone_block": "Bloc Redstone",
  "block.minecraft.redstone_lamp": "Lampa Redstone",
  "block.minecraft.redstone_ore": "Mian Redstone",
  "block.minecraft.redstone_torch": "Tóirse Redstone",
  "block.minecraft.redstone_wall_torch": "Tóirse Balla Redstone",
  "block.minecraft.redstone_wire": "Sreang Redstone",
  "block.minecraft.reinforced_deepslate": "Dúshlinn Threisithe",
  "block.minecraft.repeater": "Athsheoltóir Redstone",
  "block.minecraft.repeating_command_block": "Bloc Ordaithe Athfhillteach",
  "block.minecraft.resin_block": "Bloc Roisín",
  "block.minecraft.resin_brick_slab": "Leac Brící Roisín",
  "block.minecraft.resin_brick_stairs": "Staighre Brící Roisín",
  "block.minecraft.resin_brick_wall": "Balla Brící Roisín",
  "block.minecraft.resin_bricks": "Brící Roisín",
  "block.minecraft.resin_clump": "Meall Roisín",
  "block.minecraft.respawn_anchor": "Ancaire Athghiniúna",
  "block.minecraft.rooted_dirt": "Ithir Fhréamhaithe",
  "block.minecraft.rose_bush": "Rósóg",
  "block.minecraft.sand": "Gaineamh",
  "block.minecraft.sandstone": "Gaineamhchloch",
  "block.minecraft.sandstone_slab": "Leac Ghaineamhchloiche",
  "block.minecraft.sandstone_stairs": "Staighre Gaineamhchloiche",
  "block.minecraft.sandstone_wall": "Balla Gaineamhchloiche",
  "block.minecraft.scaffolding": "Scafall",
  "block.minecraft.sculk": "Sculk",
  "block.minecraft.sculk_catalyst": "Catalaíoch Sculk",
  "block.minecraft.sculk_sensor": "Braiteoir Sculk",
  "block.minecraft.sculk_shrieker": "Screadaire Sculk",
  "block.minecraft.sculk_vein": "Féith Sculk",
  "block.minecraft.sea_lantern": "Laindéar Mara",
  "block.minecraft.sea_pickle": "Picil Mhara",
  "block.minecraft.seagrass": "Féar Mara",
  "block.minecraft.set_spawn": "Socraíodh ionad athghiniúna",
  "block.minecraft.short_dry_grass": "Féar Gearr Tirim",
  "block.minecraft.short_grass": "Féar Gearr",
  "block.minecraft.shroomlight": "Breocán",
  "block.minecraft.shulker_box": "Bosca Shulker",
  "block.minecraft.skeleton_skull": "Cloigeann Cnámharlaigh",
  "block.minecraft.skeleton_wall_skull": "Cloigeann Balla Cnámharlaigh",
  "block.minecraft.slime_block": "Bloc Glae",
  "block.minecraft.small_amethyst_bud": "Bachlóg Bheag Aimitise",
  "block.minecraft.small_dripleaf": "Duille Silte Beag",
  "block.minecraft.smithing_table": "Bord Gabha",
  "block.minecraft.smoker": "Deataire",
  "block.minecraft.smooth_basalt": "Basalt Mín",
  "block.minecraft.smooth_quartz": "Bloc Grianchloiche Míne",
  "block.minecraft.smooth_quartz_slab": "Leac Grianchloiche Míne",
  "block.minecraft.smooth_quartz_stairs": "Staighre Grianchloiche Míne",
  "block.minecraft.smooth_red_sandstone": "Gaineamhchloch Rua Mhín",
  "block.minecraft.smooth_red_sandstone_slab": "Leac Gaineamhchloiche Rua Míne",
  "block.minecraft.smooth_red_sandstone_stairs": "Staighre Gaineamhchloiche Rua Míne",
  "block.minecraft.smooth_sandstone": "Gaineamhchloch Mhín",
  "block.minecraft.smooth_sandstone_slab": "Leac Gaineamhchloiche Míne",
  "block.minecraft.smooth_sandstone_stairs": "Staighre Gaineamhchloiche Míne",
  "block.minecraft.smooth_stone": "Cloch Mhín",
  "block.minecraft.smooth_stone_slab": "Leac Cloiche Míne",
  "block.minecraft.sniffer_egg": "Ubh Srónadóra",
  "block.minecraft.snow": "Sneachta",
  "block.minecraft.snow_block": "Bloc Sneachta",
  "block.minecraft.soul_campfire": "Tine Campa Spride",
  "block.minecraft.soul_fire": "Tine Spride",
  "block.minecraft.soul_lantern": "Laindéar Spride",
  "block.minecraft.soul_sand": "Gaineamh Spride",
  "block.minecraft.soul_soil": "Ithir Spride",
  "block.minecraft.soul_torch": "Tóirse Spride",
  "block.minecraft.soul_wall_torch": "Tóirse Balla Spride",
  "block.minecraft.spawn.not_valid": "Níl Leaba bhaile nó Ancaire Athghiniúna luchtaithe agat, nó bhí bac air",
  "block.minecraft.spawner": "Gineadóir Arrachtaí",
  "block.minecraft.spawner.desc1": "Le hubh ghiniúna:",
  "block.minecraft.spawner.desc2": "Socraíonn sé an cineál créatúir",
  "block.minecraft.sponge": "Spúinse",
  "block.minecraft.spore_blossom": "Bláth Spóir",
  "block.minecraft.spruce_button": "Cnaipe Sprúis",
  "block.minecraft.spruce_door": "Doras Sprúis",
  "block.minecraft.spruce_fence": "Claí Sprúis",
  "block.minecraft.spruce_fence_gate": "Geata Sprúis",
  "block.minecraft.spruce_hanging_sign": "Comhartha Crochta Sprúis",
  "block.minecraft.spruce_leaves": "Duilleoga Sprúis",
  "block.minecraft.spruce_log": "Bloc Sprúis",
  "block.minecraft.spruce_planks": "Cláir Sprúis",
  "block.minecraft.spruce_pressure_plate": "Brúphláta Sprúis",
  "block.minecraft.spruce_sapling": "Buinneán Sprúis",
  "block.minecraft.spruce_shelf": "Seilf Sprúis",
  "block.minecraft.spruce_sign": "Comhartha Sprúis",
  "block.minecraft.spruce_slab": "Leac Sprúis",
  "block.minecraft.spruce_stairs": "Staighre Sprúis",
  "block.minecraft.spruce_trapdoor": "Comhla Sprúis",
  "block.minecraft.spruce_wall_hanging_sign": "Comhartha Crochta Balla Sprúis",
  "block.minecraft.spruce_wall_sign": "Comhartha Balla Sprúis",
  "block.minecraft.spruce_wood": "Adhmad Sprúis",
  "block.minecraft.sticky_piston": "Loine Ghreamaitheach",
  "block.minecraft.stone": "Cloch",
  "block.minecraft.stone_brick_slab": "Leac Brící Cloiche",
  "block.minecraft.stone_brick_stairs": "Staighre Brící Cloiche",
  "block.minecraft.stone_brick_wall": "Balla Brící Cloiche",
  "block.minecraft.stone_bricks": "Brící Cloiche",
  "block.minecraft.stone_button": "Cnaipe Cloiche",
  "block.minecraft.stone_pressure_plate": "Brúphláta Cloiche",
  "block.minecraft.stone_slab": "Leac Chloiche",
  "block.minecraft.stone_stairs": "Staighre Cloiche",
  "block.minecraft.stonecutter": "Snoíodóir Cloiche",
  "block.minecraft.stripped_acacia_log": "Lomán Acáise",
  "block.minecraft.stripped_acacia_wood": "Adhmad Acáise Scafa",
  "block.minecraft.stripped_bamboo_block": "Bloc Bambú Scafa",
  "block.minecraft.stripped_birch_log": "Lomán Beithe",
  "block.minecraft.stripped_birch_wood": "Adhmad Beithe Scafa",
  "block.minecraft.stripped_cherry_log": "Lomán Silín",
  "block.minecraft.stripped_cherry_wood": "Adhmad Silín Scafa",
  "block.minecraft.stripped_crimson_hyphae": "Hífí Craoraga Scafa",
  "block.minecraft.stripped_crimson_stem": "Gas Craorag Scafa",
  "block.minecraft.stripped_dark_oak_log": "Lomán Darach Duibhe",
  "block.minecraft.stripped_dark_oak_wood": "Adhmad Darach Duibhe Scafa",
  "block.minecraft.stripped_jungle_log": "Lomán Dufaire",
  "block.minecraft.stripped_jungle_wood": "Adhmad Dufaire Scafa",
  "block.minecraft.stripped_mangrove_log": "Lomán Mangróibh",
  "block.minecraft.stripped_mangrove_wood": "Adhmad Mangróibh Scafa",
  "block.minecraft.stripped_oak_log": "Lomán Darach",
  "block.minecraft.stripped_oak_wood": "Adhmad Darach Scafa",
  "block.minecraft.stripped_pale_oak_log": "Lomán Darach Gile",
  "block.minecraft.stripped_pale_oak_wood": "Adhmad Darach Gile Scafa",
  "block.minecraft.stripped_spruce_log": "Lomán Sprúis",
  "block.minecraft.stripped_spruce_wood": "Adhmad Sprúis Scafa",
  "block.minecraft.stripped_warped_hyphae": "Hífí Saofa Scafa",
  "block.minecraft.stripped_warped_stem": "Gas Saofa Scafa",
  "block.minecraft.structure_block": "Bloc Struchtúir",
  "block.minecraft.structure_void": "Folús Struchtúir",
  "block.minecraft.sugar_cane": "Cána Siúcra",
  "block.minecraft.sunflower": "Lus na Gréine",
  "block.minecraft.suspicious_gravel": "Gairbhéal Amhrasach",
  "block.minecraft.suspicious_sand": "Gaineamh Amhrasach",
  "block.minecraft.sweet_berry_bush": "Tom Caor Milis",
  "block.minecraft.tall_dry_grass": "Féar Tirim Ard",
  "block.minecraft.tall_grass": "Féar Ard",
  "block.minecraft.tall_seagrass": "Féar Mara Ard",
  "block.minecraft.target": "Sprioc",
  "block.minecraft.terracotta": "Cré Bhruite",
  "block.minecraft.test_block": "Bloc Tástála",
  "block.minecraft.test_instance_block": "Bloc Cáis Tástála",
  "block.minecraft.tinted_glass": "Gloine Imire",
  "block.minecraft.tnt": "TNT",
  "block.minecraft.tnt.disabled": "Tá pléascanna TNT díchumasaithe",
  "block.minecraft.torch": "Tóirse",
  "block.minecraft.torchflower": "Bláth Tóirse",
  "block.minecraft.torchflower_crop": "Barr Blátha Tóirse",
  "block.minecraft.trapped_chest": "Cófra Gaiste",
  "block.minecraft.trial_spawner": "Gineadóir Trialach",
  "block.minecraft.tripwire": "Sreang Thuisle",
  "block.minecraft.tripwire_hook": "Crúca Sreinge Tuisle",
  "block.minecraft.tube_coral": "Coiréalach Píopaí",
  "block.minecraft.tube_coral_block": "Bloc Coiréalaigh Píopaí",
  "block.minecraft.tube_coral_fan": "Fean Coiréalaigh Píopaí",
  "block.minecraft.tube_coral_wall_fan": "Fean Balla Coiréalaigh Píopaí",
  "block.minecraft.tuff": "Tuf",
  "block.minecraft.tuff_brick_slab": "Leac Brící Tuf",
  "block.minecraft.tuff_brick_stairs": "Staighre Brící Tuf",
  "block.minecraft.tuff_brick_wall": "Balla Brící Tuf",
  "block.minecraft.tuff_bricks": "Brící Tuf",
  "block.minecraft.tuff_slab": "Leac Thuf",
  "block.minecraft.tuff_stairs": "Staighre Tuf",
  "block.minecraft.tuff_wall": "Balla Tuf",
  "block.minecraft.turtle_egg": "Ubh Thurtair",
  "block.minecraft.twisting_vines": "Féithleog Lúbach",
  "block.minecraft.twisting_vines_plant": "Planda Féithleoige Lúbaí",
  "block.minecraft.vault": "Taisce",
  "block.minecraft.verdant_froglight": "Frogsholas Uaine",
  "block.minecraft.vine": "Féithleog",
  "block.minecraft.void_air": "Aer Folúis",
  "block.minecraft.wall_torch": "Tóirse Balla",
  "block.minecraft.warped_button": "Cnaipe Saofa",
  "block.minecraft.warped_door": "Doras Saofa",
  "block.minecraft.warped_fence": "Claí Saofa",
  "block.minecraft.warped_fence_gate": "Geata Saofa",
  "block.minecraft.warped_fungus": "Fungas Saofa",
  "block.minecraft.warped_hanging_sign": "Comhartha Crochta Saofa",
  "block.minecraft.warped_hyphae": "Hífí Saofa",
  "block.minecraft.warped_nylium": "Níliam Saofa",
  "block.minecraft.warped_planks": "Cláir Shaofa",
  "block.minecraft.warped_pressure_plate": "Brúphláta Saofa",
  "block.minecraft.warped_roots": "Fréamhach Saofa",
  "block.minecraft.warped_shelf": "Seilf Shaofa",
  "block.minecraft.warped_sign": "Comhartha Saofa",
  "block.minecraft.warped_slab": "Leac Shaofa",
  "block.minecraft.warped_stairs": "Staighre Saofa",
  "block.minecraft.warped_stem": "Gas Saofa",
  "block.minecraft.warped_trapdoor": "Comhla Shaofa",
  "block.minecraft.warped_wall_hanging_sign": "Comhartha Crochta Balla Saofa",
  "block.minecraft.warped_wall_sign": "Comhartha Balla Saofa",
  "block.minecraft.warped_wart_block": "Bloc Lusa Nether Shaofa",
  "block.minecraft.water": "Uisce",
  "block.minecraft.water_cauldron": "Coire Uisce",
  "block.minecraft.waxed_chiseled_copper": "Copar Siséalta Céarach",
  "block.minecraft.waxed_copper_bars": "Barraí Copair Céarach",
  "block.minecraft.waxed_copper_block": "Bloc Copair Céarach",
  "block.minecraft.waxed_copper_bulb": "Bolgán Copair Céarach",
  "block.minecraft.waxed_copper_chain": "Slabhra Copair Céarach",
  "block.minecraft.waxed_copper_chest": "Cófra Copair Céarach",
  "block.minecraft.waxed_copper_door": "Doras Copair Céarach",
  "block.minecraft.waxed_copper_golem_statue": "Dealbh de Ghólam Copair Chéarach",
  "block.minecraft.waxed_copper_grate": "Gráta Copair Céarach",
  "block.minecraft.waxed_copper_lantern": "Laindéar Copair Céarach",
  "block.minecraft.waxed_copper_trapdoor": "Comhla Chopair Céarach",
  "block.minecraft.waxed_cut_copper": "Copar Gearrtha Céarach",
  "block.minecraft.waxed_cut_copper_slab": "Leac Copair Ghearrtha Chéarach",
  "block.minecraft.waxed_cut_copper_stairs": "Staighre Copair Ghearrtha Céarach",
  "block.minecraft.waxed_exposed_chiseled_copper": "Copar Siséalta Nochta Céarach",
  "block.minecraft.waxed_exposed_copper": "Copar Nochta Céarach",
  "block.minecraft.waxed_exposed_copper_bars": "Barraí Copair Nochta Céarach",
  "block.minecraft.waxed_exposed_copper_bulb": "Bolgán Copair Nochta Céarach",
  "block.minecraft.waxed_exposed_copper_chain": "Slabhra Copair Nochta Céarach",
  "block.minecraft.waxed_exposed_copper_chest": "Cófra Copair Nochta Céarach",
  "block.minecraft.waxed_exposed_copper_door": "Doras Copair Nochta Céarach",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Dealbh de Ghólam Copair Nochta Chéarach",
  "block.minecraft.waxed_exposed_copper_grate": "Gráta Copair Nochta Céarach",
  "block.minecraft.waxed_exposed_copper_lantern": "Laindéar Copair Nochta Céarach",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Comhla Copair Nochta Chéarach",
  "block.minecraft.waxed_exposed_cut_copper": "Copar Gearrtha Nochta Céarach",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Leac Copair Ghearrtha Nochta Chéarach",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Staighre Copair Ghearrtha Nochta Céarach",
  "block.minecraft.waxed_exposed_lightning_rod": "Slat Tintrí Nochta Chéarach",
  "block.minecraft.waxed_lightning_rod": "Slat Tintrí Chéarach",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Copar Siséalta Ocsaídithe Céarach",
  "block.minecraft.waxed_oxidized_copper": "Copar Ocsaídithe Céarach",
  "block.minecraft.waxed_oxidized_copper_bars": "Barraí Copair Ocsaídithe Céarach",
  "block.minecraft.waxed_oxidized_copper_bulb": "Bolgán Copair Ocsaídithe Céarach",
  "block.minecraft.waxed_oxidized_copper_chain": "Slabhra Copair Ocsaídithe Céarach",
  "block.minecraft.waxed_oxidized_copper_chest": "Cófra Copair Ocsaídithe Céarach",
  "block.minecraft.waxed_oxidized_copper_door": "Doras Copair Ocsaídithe Céarach",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Dealbh de Ghólam Copair Ocsaídithe Chéarach",
  "block.minecraft.waxed_oxidized_copper_grate": "Gráta Copair Ocsaídithe Céarach",
  "block.minecraft.waxed_oxidized_copper_lantern": "Laindéar Copair Ocsaídithe Céarach",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Comhla Copair Ocsaídithe Chéarach",
  "block.minecraft.waxed_oxidized_cut_copper": "Copar Gearrtha Ocsaídithe Céarach",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Leac Copair Ghearrtha Ocsaídithe Chéarach",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Staighre Copair Ghearrtha Ocsaídithe Céarach",
  "block.minecraft.waxed_oxidized_lightning_rod": "Slat Tintrí Ocsaídithe Chéarach",
  "block.minecraft.waxed_weathered_chiseled_copper": "Copar Siséalta Síonchaite Céarach",
  "block.minecraft.waxed_weathered_copper": "Copar Síonchaite Céarach",
  "block.minecraft.waxed_weathered_copper_bars": "Barraí Copair Síonchaite Céarach",
  "block.minecraft.waxed_weathered_copper_bulb": "Bolgán Copair Síonchaite Céarach",
  "block.minecraft.waxed_weathered_copper_chain": "Slabhra Copair Síonchaite Céarach",
  "block.minecraft.waxed_weathered_copper_chest": "Cófra Copair Síonchaite Céarach",
  "block.minecraft.waxed_weathered_copper_door": "Doras Copair Síonchaite Céarach",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Dealbh de Ghólam Copair Shíonchaite Chéarach",
  "block.minecraft.waxed_weathered_copper_grate": "Gráta Copair Síonchaite Céarach",
  "block.minecraft.waxed_weathered_copper_lantern": "Laindéar Copair Síonchaite Céarach",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Comhla Copair Shíonchaite Chéarach",
  "block.minecraft.waxed_weathered_cut_copper": "Copar Gearrtha Síonchaite Céarach",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Leac Copair Ghearrtha Shíonchaite Chéarach",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Staighre Copair Ghearrtha Síonchaite Céarach",
  "block.minecraft.waxed_weathered_lightning_rod": "Slat Tintrí Shíonchaite Chéarach",
  "block.minecraft.weathered_chiseled_copper": "Copar Siséalta Síonchaite",
  "block.minecraft.weathered_copper": "Copar Síonchaite",
  "block.minecraft.weathered_copper_bars": "Barraí Copair Síonchaite",
  "block.minecraft.weathered_copper_bulb": "Bolgán Copair Síonchaite",
  "block.minecraft.weathered_copper_chain": "Slabhra Copair Síonchaite",
  "block.minecraft.weathered_copper_chest": "Cófra Copair Síonchaite",
  "block.minecraft.weathered_copper_door": "Doras Copair Síonchaite",
  "block.minecraft.weathered_copper_golem_statue": "Dealbh de Ghólam Copair Shíonchaite",
  "block.minecraft.weathered_copper_grate": "Gráta Copair Síonchaite",
  "block.minecraft.weathered_copper_lantern": "Laindéar Copair Síonchaite",
  "block.minecraft.weathered_copper_trapdoor": "Comhla Copair Shíonchaite",
  "block.minecraft.weathered_cut_copper": "Copar Gearrtha Síonchaite",
  "block.minecraft.weathered_cut_copper_slab": "Leac Copair Ghearrtha Shíonchaite",
  "block.minecraft.weathered_cut_copper_stairs": "Staighre Copair Ghearrtha Síonchaite",
  "block.minecraft.weathered_lightning_rod": "Slat Tintrí Shíonchaite",
  "block.minecraft.weeping_vines": "Féithleog Shilte",
  "block.minecraft.weeping_vines_plant": "Planda Féithleoige Silte",
  "block.minecraft.wet_sponge": "Spúinse Fliuch",
  "block.minecraft.wheat": "Barra Cruithneachta",
  "block.minecraft.white_banner": "Meirge Bán",
  "block.minecraft.white_bed": "Leaba Bhán",
  "block.minecraft.white_candle": "Coinneal Bhán",
  "block.minecraft.white_candle_cake": "Cáca le Coinneal Bhán",
  "block.minecraft.white_carpet": "Cairpéad Bán",
  "block.minecraft.white_concrete": "Coincréit Bhán",
  "block.minecraft.white_concrete_powder": "Púdar Coincréite Bán",
  "block.minecraft.white_glazed_terracotta": "Cré Ghlónraithe Bhán",
  "block.minecraft.white_shulker_box": "Bosca Shulker Bán",
  "block.minecraft.white_stained_glass": "Gloine Bhán",
  "block.minecraft.white_stained_glass_pane": "Pána Bán",
  "block.minecraft.white_terracotta": "Cré Bhruite Bhán",
  "block.minecraft.white_tulip": "Tiúilip Bhán",
  "block.minecraft.white_wool": "Olann Bhán",
  "block.minecraft.wildflowers": "Bláthanna Fiáine",
  "block.minecraft.wither_rose": "Rós Wither",
  "block.minecraft.wither_skeleton_skull": "Cloigeann Cnámharlaigh Wither",
  "block.minecraft.wither_skeleton_wall_skull": "Cloigeann Balla Cnámharlaigh Wither",
  "block.minecraft.yellow_banner": "Meirge Buí",
  "block.minecraft.yellow_bed": "Leaba Bhuí",
  "block.minecraft.yellow_candle": "Coinneal Bhuí",
  "block.minecraft.yellow_candle_cake": "Cáca le Coinneal Bhuí",
  "block.minecraft.yellow_carpet": "Cairpéad Buí",
  "block.minecraft.yellow_concrete": "Coincréit Bhuí",
  "block.minecraft.yellow_concrete_powder": "Púdar Coincréite Buí",
  "block.minecraft.yellow_glazed_terracotta": "Cré Ghlónraithe Bhuí",
  "block.minecraft.yellow_shulker_box": "Bosca Shulker Buí",
  "block.minecraft.yellow_stained_glass": "Gloine Bhuí",
  "block.minecraft.yellow_stained_glass_pane": "Pána Buí",
  "block.minecraft.yellow_terracotta": "Cré Bhruite Bhuí",
  "block.minecraft.yellow_wool": "Olann Bhuí",
  "block.minecraft.zombie_head": "Ceann Zombaí",
  "block.minecraft.zombie_wall_head": "Ceann Balla Zombaí",
  "item.minecraft.acacia_boat": "Bád Acáise",
  "item.minecraft.acacia_chest_boat": "Bád Acáise le Cófra",
  "item.minecraft.allay_spawn_egg": "Ubh Ghiniúna Fulangaithe",
  "item.minecraft.amethyst_shard": "Scealp Aimitise",
  "item.minecraft.angler_pottery_shard": "Scealp Cré an Iascaire",
  "item.minecraft.angler_pottery_sherd": "Scealp Cré an Iascaire",
  "item.minecraft.apple": "Úll",
  "item.minecraft.archer_pottery_shard": "Scealp Cré an Bhoghdóra",
  "item.minecraft.archer_pottery_sherd": "Scealp Cré an Bhoghdóra",
  "item.minecraft.armadillo_scute": "Slige Armadailín",
  "item.minecraft.armadillo_spawn_egg": "Ubh Ghiniúna Armadailíní",
  "item.minecraft.armor_stand": "Seastán Cathéide",
  "item.minecraft.arms_up_pottery_shard": "Scealp Cré Lámha in Airde",
  "item.minecraft.arms_up_pottery_sherd": "Scealp Cré Lámha in Airde",
  "item.minecraft.arrow": "Saighead",
  "item.minecraft.axolotl_bucket": "Buicéad Acsalatal",
  "item.minecraft.axolotl_spawn_egg": "Ubh Ghiniúna Acsalatal",
  "item.minecraft.baked_potato": "Práta Rósta",
  "item.minecraft.bamboo_chest_raft": "Rafta Bambú le Cófra",
  "item.minecraft.bamboo_raft": "Rafta Bambú",
  "item.minecraft.bat_spawn_egg": "Ubh Ghiniúna Ialtóg",
  "item.minecraft.bee_spawn_egg": "Ubh Ghiniúna Beach",
  "item.minecraft.beef": "Mairteoil Amh",
  "item.minecraft.beetroot": "Biatas",
  "item.minecraft.beetroot_seeds": "Síolta Biatais",
  "item.minecraft.beetroot_soup": "Anraith Biatas",
  "item.minecraft.birch_boat": "Bád Beithe",
  "item.minecraft.birch_chest_boat": "Bád Beithe le Cófra",
  "item.minecraft.black_bundle": "Mála Dubh",
  "item.minecraft.black_dye": "Ruaim Dhubh",
  "item.minecraft.black_harness": "Úim Dhubh",
  "item.minecraft.blade_pottery_shard": "Scealp Cré na Lainne",
  "item.minecraft.blade_pottery_sherd": "Scealp Cré na Lainne",
  "item.minecraft.blaze_powder": "Púdar Lasaire",
  "item.minecraft.blaze_rod": "Slat Lasaire",
  "item.minecraft.blaze_spawn_egg": "Ubh Ghiniúna Lasairí",
  "item.minecraft.blue_bundle": "Mála Gorm",
  "item.minecraft.blue_dye": "Ruaim Ghorm",
  "item.minecraft.blue_egg": "Ubh Ghorm",
  "item.minecraft.blue_harness": "Úim Ghorm",
  "item.minecraft.bogged_spawn_egg": "Ubh Ghiniúna Abarán",
  "item.minecraft.bolt_armor_trim_smithing_template": "Múnla Gaibhneachta",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Maisiú Cathéide de Sheamanna",
  "item.minecraft.bone": "Cnámh",
  "item.minecraft.bone_meal": "Min Chnámh",
  "item.minecraft.book": "Leabhar",
  "item.minecraft.bordure_indented_banner_pattern": "Patrún Meirge d'Imeallbhord Eangach",
  "item.minecraft.bow": "Bogha",
  "item.minecraft.bowl": "Babhla",
  "item.minecraft.bread": "Arán",
  "item.minecraft.breeze_rod": "Slat Gaotháin",
  "item.minecraft.breeze_spawn_egg": "Ubh Ghiniúna Gaothán",
  "item.minecraft.brewer_pottery_shard": "Scealp Cré an Ghrúdaire",
  "item.minecraft.brewer_pottery_sherd": "Scealp Cré an Ghrúdaire",
  "item.minecraft.brewing_stand": "Stil",
  "item.minecraft.brick": "Bríce",
  "item.minecraft.brown_bundle": "Mála Donn",
  "item.minecraft.brown_dye": "Ruaim Dhonn",
  "item.minecraft.brown_egg": "Ubh Dhonn",
  "item.minecraft.brown_harness": "Úim Dhonn",
  "item.minecraft.brush": "Scuaibín",
  "item.minecraft.bucket": "Buicéad",
  "item.minecraft.bundle": "Mála",
  "item.minecraft.bundle.empty": "Folamh",
  "item.minecraft.bundle.empty.description": "Is féidir carn d'earraí éagsúla a choinneáil ann",
  "item.minecraft.bundle.full": "Lán",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Scealp Cré na Tine",
  "item.minecraft.burn_pottery_sherd": "Scealp Cré na Tine",
  "item.minecraft.camel_husk_spawn_egg": "Ubh Ghiniúna Camall Seargtha",
  "item.minecraft.camel_spawn_egg": "Ubh Ghiniúna Camall",
  "item.minecraft.carrot": "Cairéad",
  "item.minecraft.carrot_on_a_stick": "Cairéad ar Maide",
  "item.minecraft.cat_spawn_egg": "Ubh Ghiniúna Cat",
  "item.minecraft.cauldron": "Coire",
  "item.minecraft.cave_spider_spawn_egg": "Ubh Ghiniúna Damhán Alla Uaimhe",
  "item.minecraft.chainmail_boots": "Bróga Máille",
  "item.minecraft.chainmail_chestplate": "Lúireach Mháille",
  "item.minecraft.chainmail_helmet": "Clogad Máille",
  "item.minecraft.chainmail_leggings": "Loirgneáin Mháille",
  "item.minecraft.charcoal": "Gualach",
  "item.minecraft.cherry_boat": "Bád Silín",
  "item.minecraft.cherry_chest_boat": "Bád Silín le Cófra",
  "item.minecraft.chest_minecart": "Cairt le Cófra",
  "item.minecraft.chicken": "Sicín Amh",
  "item.minecraft.chicken_spawn_egg": "Ubh Ghiniúna Sicíní",
  "item.minecraft.chorus_fruit": "Úll an Cheoil",
  "item.minecraft.clay_ball": "Meall Cré",
  "item.minecraft.clock": "Clog",
  "item.minecraft.coal": "Gual",
  "item.minecraft.coast_armor_trim_smithing_template": "Múnla Gaibhneachta",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Maisiú Cathéide de Chósta",
  "item.minecraft.cocoa_beans": "Pónairí Cacó",
  "item.minecraft.cod": "Trosc Amh",
  "item.minecraft.cod_bucket": "Trosc i mBuicéad",
  "item.minecraft.cod_spawn_egg": "Ubh Ghiniúna Trosc",
  "item.minecraft.command_block_minecart": "Cairt le Bloc Ordaithe",
  "item.minecraft.compass": "Compás",
  "item.minecraft.cooked_beef": "Stéig",
  "item.minecraft.cooked_chicken": "Sicín Rósta",
  "item.minecraft.cooked_cod": "Trosc Rósta",
  "item.minecraft.cooked_mutton": "Caoireoil Rósta",
  "item.minecraft.cooked_porkchop": "Muiceoil Rósta",
  "item.minecraft.cooked_rabbit": "Coinín Rósta",
  "item.minecraft.cooked_salmon": "Bradán Rósta",
  "item.minecraft.cookie": "Briosca",
  "item.minecraft.copper_axe": "Tua Chopair",
  "item.minecraft.copper_boots": "Bróga Copair",
  "item.minecraft.copper_chestplate": "Lúireach Chopair",
  "item.minecraft.copper_golem_spawn_egg": "Ubh Ghiniúna Gólam Copair",
  "item.minecraft.copper_helmet": "Clogad Copair",
  "item.minecraft.copper_hoe": "Grafóg Chopair",
  "item.minecraft.copper_horse_armor": "Cathéide Chopair do Chapall",
  "item.minecraft.copper_ingot": "Tinne Copair",
  "item.minecraft.copper_leggings": "Loirgneáin Chopair",
  "item.minecraft.copper_nautilus_armor": "Cathéide Chopair do Nátalas",
  "item.minecraft.copper_nugget": "Cnap Copair",
  "item.minecraft.copper_pickaxe": "Piocóid Chopair",
  "item.minecraft.copper_shovel": "Sluasaid Chopair",
  "item.minecraft.copper_spear": "Sleá Chopair",
  "item.minecraft.copper_sword": "Claíomh Copair",
  "item.minecraft.cow_spawn_egg": "Ubh Ghiniúna Bó",
  "item.minecraft.creaking_spawn_egg": "Ubh Ghiniúna Díoscánaithe",
  "item.minecraft.creeper_banner_pattern": "Patrún Meirge",
  "item.minecraft.creeper_banner_pattern.desc": "Fíor Creeper",
  "item.minecraft.creeper_banner_pattern.new": "Patrún Meirge d'Fhíor Creeper",
  "item.minecraft.creeper_spawn_egg": "Ubh Ghiniúna Creeper",
  "item.minecraft.crossbow": "Crosbhogha",
  "item.minecraft.crossbow.projectile": "Diúracán:",
  "item.minecraft.crossbow.projectile.multiple": "Diúracán: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Diúracán: %s",
  "item.minecraft.cyan_bundle": "Mála Cian",
  "item.minecraft.cyan_dye": "Ruaim Chian",
  "item.minecraft.cyan_harness": "Úim Chian",
  "item.minecraft.danger_pottery_shard": "Scealp Cré an Creeper",
  "item.minecraft.danger_pottery_sherd": "Scealp Cré an Creeper",
  "item.minecraft.dark_oak_boat": "Bád Darach Duibhe",
  "item.minecraft.dark_oak_chest_boat": "Bád Darach Duibhe le Cófra",
  "item.minecraft.debug_stick": "Baitín Dífhabhtaithe",
  "item.minecraft.debug_stick.empty": "Níl aon airí ag %s",
  "item.minecraft.debug_stick.select": "\"%s\" roghnaithe (%s)",
  "item.minecraft.debug_stick.update": "\"%s\" mar %s",
  "item.minecraft.diamond": "Diamant",
  "item.minecraft.diamond_axe": "Tua Dhiamaint",
  "item.minecraft.diamond_boots": "Bróga Diamaint",
  "item.minecraft.diamond_chestplate": "Lúireach Dhiamaint",
  "item.minecraft.diamond_helmet": "Clogad Diamaint",
  "item.minecraft.diamond_hoe": "Grafóg Dhiamaint",
  "item.minecraft.diamond_horse_armor": "Cathéide Dhiamaint do Chapall",
  "item.minecraft.diamond_leggings": "Loirgneáin Diamaint",
  "item.minecraft.diamond_nautilus_armor": "Cathéide Dhiamaint do Nátalas",
  "item.minecraft.diamond_pickaxe": "Piocóid Diamaint",
  "item.minecraft.diamond_shovel": "Sluasaid Diamaint",
  "item.minecraft.diamond_spear": "Sleá Dhiamaint",
  "item.minecraft.diamond_sword": "Claíomh Diamaint",
  "item.minecraft.disc_fragment_5": "Blúire Diosca",
  "item.minecraft.disc_fragment_5.desc": "Diosca Ceoil - 5",
  "item.minecraft.dolphin_spawn_egg": "Ubh Ghiniúna Deilfeanna",
  "item.minecraft.donkey_spawn_egg": "Ubh Ghiniúna Asal",
  "item.minecraft.dragon_breath": "Anáil Dragain",
  "item.minecraft.dried_kelp": "Ceilp Thriomaithe",
  "item.minecraft.drowned_spawn_egg": "Ubh Ghiniúna Báiteachán",
  "item.minecraft.dune_armor_trim_smithing_template": "Múnla Gaibhneachta",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Maisiú Cathéide de Dhumhach",
  "item.minecraft.echo_shard": "Scealp an Mhacalla",
  "item.minecraft.egg": "Ubh",
  "item.minecraft.elder_guardian_spawn_egg": "Ubh Ghiniúna Coimeádaithe Sinsearacha",
  "item.minecraft.elytra": "Eilitrim",
  "item.minecraft.emerald": "Smaragaid",
  "item.minecraft.enchanted_book": "Leabhar Draíochta",
  "item.minecraft.enchanted_golden_apple": "Úll Óir Draíochta",
  "item.minecraft.end_crystal": "Criostal End",
  "item.minecraft.ender_dragon_spawn_egg": "Ubh Ghiniúna Dhragan Ender",
  "item.minecraft.ender_eye": "Súil Ender",
  "item.minecraft.ender_pearl": "Péarla Ender",
  "item.minecraft.enderman_spawn_egg": "Ubh Ghiniúna Enderman",
  "item.minecraft.endermite_spawn_egg": "Ubh Ghiniúna Endermite",
  "item.minecraft.evoker_spawn_egg": "Ubh Ghiniúna Gairmneachán",
  "item.minecraft.experience_bottle": "Buidéal Asarlaíochta",
  "item.minecraft.explorer_pottery_shard": "Scealp Cré na Léarscáile",
  "item.minecraft.explorer_pottery_sherd": "Scealp Cré na Léarscáile",
  "item.minecraft.eye_armor_trim_smithing_template": "Múnla Gaibhneachta",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Maisiú Cathéide de Shúil",
  "item.minecraft.feather": "Cleite",
  "item.minecraft.fermented_spider_eye": "Súil Damháin Alla Coipthe",
  "item.minecraft.field_masoned_banner_pattern": "Patrún Meirge de Mhachaire Saoirsithe",
  "item.minecraft.filled_map": "Léarscáil",
  "item.minecraft.fire_charge": "Lánán Tine",
  "item.minecraft.firework_rocket": "Roicéad Tine Ealaíne",
  "item.minecraft.firework_rocket.flight": "Tréimhse Eitilte:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Réalta Tine Ealaíne",
  "item.minecraft.firework_star.black": "Dubh",
  "item.minecraft.firework_star.blue": "Gorm",
  "item.minecraft.firework_star.brown": "Donn",
  "item.minecraft.firework_star.custom_color": "Saincheaptha",
  "item.minecraft.firework_star.cyan": "Cian",
  "item.minecraft.firework_star.fade_to": "Tiontaíonn sé ar",
  "item.minecraft.firework_star.flicker": "Drithleach",
  "item.minecraft.firework_star.gray": "Liath",
  "item.minecraft.firework_star.green": "Uaine",
  "item.minecraft.firework_star.light_blue": "Bánghorm",
  "item.minecraft.firework_star.light_gray": "Fionnliath",
  "item.minecraft.firework_star.lime": "Glasuaine",
  "item.minecraft.firework_star.magenta": "Maigeanta",
  "item.minecraft.firework_star.orange": "Oráiste",
  "item.minecraft.firework_star.pink": "Bándearg",
  "item.minecraft.firework_star.purple": "Corcra",
  "item.minecraft.firework_star.red": "Dearg",
  "item.minecraft.firework_star.shape": "Cruth Anaithnid",
  "item.minecraft.firework_star.shape.burst": "Pléascach",
  "item.minecraft.firework_star.shape.creeper": "Cruth an Creeper",
  "item.minecraft.firework_star.shape.large_ball": "Liathróid Mhór",
  "item.minecraft.firework_star.shape.small_ball": "Liathróid Bheag",
  "item.minecraft.firework_star.shape.star": "Réaltchruthach",
  "item.minecraft.firework_star.trail": "Rian",
  "item.minecraft.firework_star.white": "Bán",
  "item.minecraft.firework_star.yellow": "Buí",
  "item.minecraft.fishing_rod": "Slat Iascaigh",
  "item.minecraft.flint": "Breochloch",
  "item.minecraft.flint_and_steel": "Breochloch is Cruach",
  "item.minecraft.flow_armor_trim_smithing_template": "Múnla Gaibhneachta",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Maisiú Cathéide de Bhís",
  "item.minecraft.flow_banner_pattern": "Patrún Meirge",
  "item.minecraft.flow_banner_pattern.desc": "Bís",
  "item.minecraft.flow_banner_pattern.new": "Patrún Meirge de Bhís",
  "item.minecraft.flow_pottery_sherd": "Scealp Cré na Bíse",
  "item.minecraft.flower_banner_pattern": "Patrún Meirge",
  "item.minecraft.flower_banner_pattern.desc": "Fíor Blátha",
  "item.minecraft.flower_banner_pattern.new": "Patrún Meirge d'Fhíor Blátha",
  "item.minecraft.flower_pot": "Pota Bláthanna",
  "item.minecraft.fox_spawn_egg": "Ubh Ghiniúna Sionnach",
  "item.minecraft.friend_pottery_shard": "Scealp Cré an Chairdis",
  "item.minecraft.friend_pottery_sherd": "Scealp Cré an Chairdis",
  "item.minecraft.frog_spawn_egg": "Ubh Ghiniúna Froganna",
  "item.minecraft.furnace_minecart": "Cairt le Foirnéis",
  "item.minecraft.ghast_spawn_egg": "Ubh Ghiniúna Ghast",
  "item.minecraft.ghast_tear": "Deoir an Ghast",
  "item.minecraft.glass_bottle": "Buidéal Gloine",
  "item.minecraft.glistering_melon_slice": "Slis Mealbhacáin Lonrach",
  "item.minecraft.globe_banner_pattern": "Patrún Meirge",
  "item.minecraft.globe_banner_pattern.desc": "Cruinneog",
  "item.minecraft.globe_banner_pattern.new": "Patrún Meirge de Chruinneog",
  "item.minecraft.glow_berries": "Caora Lonracha",
  "item.minecraft.glow_ink_sac": "Sac Dúigh Lonrach",
  "item.minecraft.glow_item_frame": "Fráma Lonrach",
  "item.minecraft.glow_squid_spawn_egg": "Ubh Ghiniúna Scuideanna Lonracha",
  "item.minecraft.glowstone_dust": "Deannach Loinríte",
  "item.minecraft.goat_horn": "Adharc Gabhair",
  "item.minecraft.goat_spawn_egg": "Ubh Ghiniúna Gabhar",
  "item.minecraft.gold_ingot": "Tinne Óir",
  "item.minecraft.gold_nugget": "Cnap Óir",
  "item.minecraft.golden_apple": "Úll Óir",
  "item.minecraft.golden_axe": "Tua Óir",
  "item.minecraft.golden_boots": "Bróga Óir",
  "item.minecraft.golden_carrot": "Cairéad Óir",
  "item.minecraft.golden_chestplate": "Lúireach Óir",
  "item.minecraft.golden_helmet": "Clogad Óir",
  "item.minecraft.golden_hoe": "Grafóg Óir",
  "item.minecraft.golden_horse_armor": "Cathéide Óir do Chapall",
  "item.minecraft.golden_leggings": "Loirgneáin Óir",
  "item.minecraft.golden_nautilus_armor": "Cathéide Óir do Nátalas",
  "item.minecraft.golden_pickaxe": "Piocóid Óir",
  "item.minecraft.golden_shovel": "Sluasaid Óir",
  "item.minecraft.golden_spear": "Sleá Óir",
  "item.minecraft.golden_sword": "Claíomh Óir",
  "item.minecraft.gray_bundle": "Mála Liath",
  "item.minecraft.gray_dye": "Ruaim Liath",
  "item.minecraft.gray_harness": "Úim Liath",
  "item.minecraft.green_bundle": "Mála Uaine",
  "item.minecraft.green_dye": "Ruaim Uaine",
  "item.minecraft.green_harness": "Úim Uaine",
  "item.minecraft.guardian_spawn_egg": "Ubh Ghiniúna Coimeádaithe",
  "item.minecraft.gunpowder": "Púdar Gunna",
  "item.minecraft.guster_banner_pattern": "Patrún Meirge",
  "item.minecraft.guster_banner_pattern.desc": "Fíor Gaotháin",
  "item.minecraft.guster_banner_pattern.new": "Patrún Meirge d'Fhíor Gaotháin",
  "item.minecraft.guster_pottery_sherd": "Scealp Cré an Ghaotháin",
  "item.minecraft.happy_ghast_spawn_egg": "Ubh Ghiniúna Ghast Shásta",
  "item.minecraft.harness": "Úim",
  "item.minecraft.heart_of_the_sea": "Croí na Mara",
  "item.minecraft.heart_pottery_shard": "Scealp Cré an Chroí",
  "item.minecraft.heart_pottery_sherd": "Scealp Cré an Chroí",
  "item.minecraft.heartbreak_pottery_shard": "Scealp Cré an Chroíbhriste",
  "item.minecraft.heartbreak_pottery_sherd": "Scealp Cré an Chroíbhriste",
  "item.minecraft.hoglin_spawn_egg": "Ubh Ghiniúna Hoglin",
  "item.minecraft.honey_bottle": "Buidéal Meala",
  "item.minecraft.honeycomb": "Milteog",
  "item.minecraft.hopper_minecart": "Cairt le Crannóg",
  "item.minecraft.horse_spawn_egg": "Ubh Ghiniúna Capall",
  "item.minecraft.host_armor_trim_smithing_template": "Múnla Gaibhneachta",
  "item.minecraft.host_armor_trim_smithing_template.new": "Maisiú Cathéide d'Óstach",
  "item.minecraft.howl_pottery_shard": "Scealp Cré an Mhic Tíre",
  "item.minecraft.howl_pottery_sherd": "Scealp Cré an Mhic Tíre",
  "item.minecraft.husk_spawn_egg": "Ubh Ghiniúna Seargán",
  "item.minecraft.ink_sac": "Sac Dúigh",
  "item.minecraft.iron_axe": "Tua Iarainn",
  "item.minecraft.iron_boots": "Bróga Iarainn",
  "item.minecraft.iron_chestplate": "Lúireach Iarainn",
  "item.minecraft.iron_golem_spawn_egg": "Ubh Ghiniúna Gólam Iarainn",
  "item.minecraft.iron_helmet": "Clogad Iarainn",
  "item.minecraft.iron_hoe": "Grafóg Iarainn",
  "item.minecraft.iron_horse_armor": "Cathéide Iarainn do Chapall",
  "item.minecraft.iron_ingot": "Tinne Iarainn",
  "item.minecraft.iron_leggings": "Loirgneáin Iarainn",
  "item.minecraft.iron_nautilus_armor": "Cathéide Iarainn do Nátalas",
  "item.minecraft.iron_nugget": "Cnap Iarainn",
  "item.minecraft.iron_pickaxe": "Piocóid Iarainn",
  "item.minecraft.iron_shovel": "Sluasaid Iarainn",
  "item.minecraft.iron_spear": "Sleá Iarainn",
  "item.minecraft.iron_sword": "Claíomh Iarainn",
  "item.minecraft.item_frame": "Fráma",
  "item.minecraft.jungle_boat": "Bád Dufaire",
  "item.minecraft.jungle_chest_boat": "Bád Dufaire le Cófra",
  "item.minecraft.knowledge_book": "Leabhar Eolais",
  "item.minecraft.lapis_lazuli": "Lapis Lazuli",
  "item.minecraft.lava_bucket": "Buicéad Laibhe",
  "item.minecraft.lead": "Iall",
  "item.minecraft.leather": "Leathar",
  "item.minecraft.leather_boots": "Bróga Leathair",
  "item.minecraft.leather_chestplate": "Ionar Leathair",
  "item.minecraft.leather_helmet": "Caipín Leathair",
  "item.minecraft.leather_horse_armor": "Cathéide Leathair do Chapall",
  "item.minecraft.leather_leggings": "Bríste Leathair",
  "item.minecraft.light_blue_bundle": "Mála Bánghorm",
  "item.minecraft.light_blue_dye": "Ruaim Bhánghorm",
  "item.minecraft.light_blue_harness": "Úim Bhánghorm",
  "item.minecraft.light_gray_bundle": "Mála Fionnliath",
  "item.minecraft.light_gray_dye": "Ruaim Fhionnliath",
  "item.minecraft.light_gray_harness": "Úim Fhionnliath",
  "item.minecraft.lime_bundle": "Mála Glasuaine",
  "item.minecraft.lime_dye": "Ruaim Ghlasuaine",
  "item.minecraft.lime_harness": "Úim Ghlasuaine",
  "item.minecraft.lingering_potion": "Posóid Righin",
  "item.minecraft.lingering_potion.effect.awkward": "Posóid Righin Chiotach",
  "item.minecraft.lingering_potion.effect.empty": "Posóid Righin Dhochumtha",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Posóid Righin na Tinedhíonachta",
  "item.minecraft.lingering_potion.effect.harming": "Posóid Righin an Dochair",
  "item.minecraft.lingering_potion.effect.healing": "Posóid Righin an Leighis",
  "item.minecraft.lingering_potion.effect.infested": "Posóid Righin an Fhínithe",
  "item.minecraft.lingering_potion.effect.invisibility": "Posóid Righin na Dofheictheachta",
  "item.minecraft.lingering_potion.effect.leaping": "Posóid Righin na Léime",
  "item.minecraft.lingering_potion.effect.levitation": "Posóid Righin na Foluana",
  "item.minecraft.lingering_potion.effect.luck": "Posóid Righin an Áidh",
  "item.minecraft.lingering_potion.effect.mundane": "Posóid Righin Leamh",
  "item.minecraft.lingering_potion.effect.night_vision": "Posóid Righin Radhairc Oíche",
  "item.minecraft.lingering_potion.effect.oozing": "Posóid Righin an Phúscáin",
  "item.minecraft.lingering_potion.effect.poison": "Posóid Righin na Nimhe",
  "item.minecraft.lingering_potion.effect.regeneration": "Posóid Righin na hAthghiniúna",
  "item.minecraft.lingering_potion.effect.slow_falling": "Posóid Righin na Mallthitime",
  "item.minecraft.lingering_potion.effect.slowness": "Posóid Righin na Moille",
  "item.minecraft.lingering_potion.effect.strength": "Posóid Righin an Nirt",
  "item.minecraft.lingering_potion.effect.swiftness": "Posóid Righin an Luais",
  "item.minecraft.lingering_potion.effect.thick": "Posóid Righin Thiubh",
  "item.minecraft.lingering_potion.effect.turtle_master": "Posóid Righin Mháistir na dTurtar",
  "item.minecraft.lingering_potion.effect.water": "Buidéal Uisce Righin",
  "item.minecraft.lingering_potion.effect.water_breathing": "Posóid Righin Análú in Uisce",
  "item.minecraft.lingering_potion.effect.weakness": "Posóid Righin na Laige",
  "item.minecraft.lingering_potion.effect.weaving": "Posóid Righin na Fíodóireachta",
  "item.minecraft.lingering_potion.effect.wind_charged": "Posóid Righin an Lánáin Ghaoithe",
  "item.minecraft.llama_spawn_egg": "Ubh Ghiniúna Lámaí",
  "item.minecraft.lodestone_compass": "Compás Adhmainte",
  "item.minecraft.mace": "Más",
  "item.minecraft.magenta_bundle": "Mála Maigeanta",
  "item.minecraft.magenta_dye": "Ruaim Mhaigeanta",
  "item.minecraft.magenta_harness": "Úim Mhaigeanta",
  "item.minecraft.magma_cream": "Uachtar Magma",
  "item.minecraft.magma_cube_spawn_egg": "Ubh Ghiniúna Ciúbanna Magma",
  "item.minecraft.mangrove_boat": "Bád Mangróibh",
  "item.minecraft.mangrove_chest_boat": "Bád Mangróibh le Cófra",
  "item.minecraft.map": "Léarscáil Bhán",
  "item.minecraft.melon_seeds": "Síolta Mealbhacáin",
  "item.minecraft.melon_slice": "Slis Mhealbhacáin",
  "item.minecraft.milk_bucket": "Buicéad Bainne",
  "item.minecraft.minecart": "Cairt",
  "item.minecraft.miner_pottery_shard": "Scealp Cré an Mhianadóra",
  "item.minecraft.miner_pottery_sherd": "Scealp Cré an Mhianadóra",
  "item.minecraft.mojang_banner_pattern": "Patrún Meirge",
  "item.minecraft.mojang_banner_pattern.desc": "Rud",
  "item.minecraft.mojang_banner_pattern.new": "Patrún Meirge de Rud",
  "item.minecraft.mooshroom_spawn_egg": "Ubh Ghiniúna Mooshroom",
  "item.minecraft.mourner_pottery_shard": "Scealp Cré an Mhaoir",
  "item.minecraft.mourner_pottery_sherd": "Scealp Cré an Mhaoir",
  "item.minecraft.mule_spawn_egg": "Ubh Ghiniúna Miúileanna",
  "item.minecraft.mushroom_stew": "Stobhach Beacán",
  "item.minecraft.music_disc_11": "Diosca Ceoil",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Diosca Ceoil",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Diosca Ceoil",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "Diosca Ceoil",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Diosca Ceoil",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Diosca Ceoil",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Diosca Ceoil",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "Diosca Ceoil",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator (Bosca Ceoil)",
  "item.minecraft.music_disc_far": "Diosca Ceoil",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Diosca Ceoil",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "Diosca Ceoil",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Diosca Ceoil",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Diosca Ceoil",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - otherside",
  "item.minecraft.music_disc_pigstep": "Diosca Ceoil",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "Diosca Ceoil",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "Diosca Ceoil",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "Diosca Ceoil",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Diosca Ceoil",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Diosca Ceoil",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "Diosca Ceoil",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Diosca Ceoil",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Caoireoil Amh",
  "item.minecraft.name_tag": "Lipéad Ainm",
  "item.minecraft.nautilus_shell": "Blaosc Nátalais",
  "item.minecraft.nautilus_spawn_egg": "Ubh Ghiniúna Nátalas",
  "item.minecraft.nether_brick": "Bríce Nether",
  "item.minecraft.nether_star": "Réalta an Nether",
  "item.minecraft.nether_wart": "Lus an Nether",
  "item.minecraft.netherite_axe": "Tua Netheríte",
  "item.minecraft.netherite_boots": "Bróga Netheríte",
  "item.minecraft.netherite_chestplate": "Lúireach Netheríte",
  "item.minecraft.netherite_helmet": "Clogad Netheríte",
  "item.minecraft.netherite_hoe": "Grafóg Netheríte",
  "item.minecraft.netherite_horse_armor": "Cathéide Netheríte do Chapall",
  "item.minecraft.netherite_ingot": "Tinne Netheríte",
  "item.minecraft.netherite_leggings": "Loirgneáin Netheríte",
  "item.minecraft.netherite_nautilus_armor": "Cathéide Netheríte do Nátalas",
  "item.minecraft.netherite_pickaxe": "Piocóid Netheríte",
  "item.minecraft.netherite_scrap": "Dramh Netheríte",
  "item.minecraft.netherite_shovel": "Sluasaid Netheríte",
  "item.minecraft.netherite_spear": "Sleá Netheríte",
  "item.minecraft.netherite_sword": "Claíomh Netheríte",
  "item.minecraft.netherite_upgrade_smithing_template": "Múnla Gaibhneachta",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Uasghrádú Netheríte",
  "item.minecraft.oak_boat": "Bád Darach",
  "item.minecraft.oak_chest_boat": "Bád Darach le Cófra",
  "item.minecraft.ocelot_spawn_egg": "Ubh Ghiniúna Osalat",
  "item.minecraft.ominous_bottle": "Buidéal Tuarúil",
  "item.minecraft.ominous_trial_key": "Eochair Thrialach Thuarúil",
  "item.minecraft.orange_bundle": "Mála Oráiste",
  "item.minecraft.orange_dye": "Ruaim Oráiste",
  "item.minecraft.orange_harness": "Úim Oráiste",
  "item.minecraft.painting": "Pictiúr",
  "item.minecraft.pale_oak_boat": "Bád Darach Gile",
  "item.minecraft.pale_oak_chest_boat": "Bád Darach Gile le Cófra",
  "item.minecraft.panda_spawn_egg": "Ubh Ghiniúna Pandaí",
  "item.minecraft.paper": "Páipéar",
  "item.minecraft.parched_spawn_egg": "Ubh Ghiniúna Cnámharlach Fásaigh",
  "item.minecraft.parrot_spawn_egg": "Ubh Ghiniúna Pearóidí",
  "item.minecraft.phantom_membrane": "Seicin Púca",
  "item.minecraft.phantom_spawn_egg": "Ubh Ghiniúna Púcaí",
  "item.minecraft.pig_spawn_egg": "Ubh Ghiniúna Muc",
  "item.minecraft.piglin_banner_pattern": "Patrún Meirge",
  "item.minecraft.piglin_banner_pattern.desc": "Soc",
  "item.minecraft.piglin_banner_pattern.new": "Patrún Meirge de Shoc",
  "item.minecraft.piglin_brute_spawn_egg": "Ubh Ghiniúna Piglin Barbartha",
  "item.minecraft.piglin_spawn_egg": "Ubh Ghiniúna Piglin",
  "item.minecraft.pillager_spawn_egg": "Ubh Ghiniúna Creachadóirí",
  "item.minecraft.pink_bundle": "Mála Bándearg",
  "item.minecraft.pink_dye": "Ruaim Bhándearg",
  "item.minecraft.pink_harness": "Úim Bhándearg",
  "item.minecraft.pitcher_plant": "Ascaid",
  "item.minecraft.pitcher_pod": "Faighneog Ascaide",
  "item.minecraft.plenty_pottery_shard": "Scealp Cré an Chófra",
  "item.minecraft.plenty_pottery_sherd": "Scealp Cré an Chófra",
  "item.minecraft.poisonous_potato": "Práta Lofa",
  "item.minecraft.polar_bear_spawn_egg": "Ubh Ghiniúna Béar Bán",
  "item.minecraft.popped_chorus_fruit": "Úll Ceoil Rósta",
  "item.minecraft.porkchop": "Muiceoil Amh",
  "item.minecraft.potato": "Práta",
  "item.minecraft.potion": "Posóid",
  "item.minecraft.potion.effect.awkward": "Posóid Chiotach",
  "item.minecraft.potion.effect.empty": "Posóid Dhochumtha",
  "item.minecraft.potion.effect.fire_resistance": "Posóid na Tinedhíonachta",
  "item.minecraft.potion.effect.harming": "Posóid an Dochair",
  "item.minecraft.potion.effect.healing": "Posóid an Leighis",
  "item.minecraft.potion.effect.infested": "Posóid an Fhínithe",
  "item.minecraft.potion.effect.invisibility": "Posóid na Dofheictheachta",
  "item.minecraft.potion.effect.leaping": "Posóid na Léime",
  "item.minecraft.potion.effect.levitation": "Posóid na Foluana",
  "item.minecraft.potion.effect.luck": "Posóid an Áidh",
  "item.minecraft.potion.effect.mundane": "Posóid Leamh",
  "item.minecraft.potion.effect.night_vision": "Posóid Radhairc Oíche",
  "item.minecraft.potion.effect.oozing": "Posóid an Phúscáin",
  "item.minecraft.potion.effect.poison": "Posóid na Nimhe",
  "item.minecraft.potion.effect.regeneration": "Posóid na hAthghiniúna",
  "item.minecraft.potion.effect.slow_falling": "Posóid na Mallthitime",
  "item.minecraft.potion.effect.slowness": "Posóid na Moille",
  "item.minecraft.potion.effect.strength": "Posóid an Nirt",
  "item.minecraft.potion.effect.swiftness": "Posóid an Luais",
  "item.minecraft.potion.effect.thick": "Posóid Thiubh",
  "item.minecraft.potion.effect.turtle_master": "Posóid Mháistir na dTurtar",
  "item.minecraft.potion.effect.water": "Buidéal Uisce",
  "item.minecraft.potion.effect.water_breathing": "Posóid Análú in Uisce",
  "item.minecraft.potion.effect.weakness": "Posóid na Laige",
  "item.minecraft.potion.effect.weaving": "Posóid na Fíodóireachta",
  "item.minecraft.potion.effect.wind_charged": "Posóid an Lánáin Ghaoithe",
  "item.minecraft.pottery_shard_archer": "Scealp Cré an Bhoghdóra",
  "item.minecraft.pottery_shard_arms_up": "Scealp Cré Lámha in Airde",
  "item.minecraft.pottery_shard_prize": "Scealp Cré an tSéada",
  "item.minecraft.pottery_shard_skull": "Scealp Cré an Chloiginn",
  "item.minecraft.powder_snow_bucket": "Buicéad Púdair Shneachta",
  "item.minecraft.prismarine_crystals": "Criostail Phriosmuirín",
  "item.minecraft.prismarine_shard": "Scealp Phriosmuirín",
  "item.minecraft.prize_pottery_shard": "Scealp Cré an tSéada",
  "item.minecraft.prize_pottery_sherd": "Scealp Cré an tSéada",
  "item.minecraft.pufferfish": "Iasc Bolgach",
  "item.minecraft.pufferfish_bucket": "Iasc Bolgach i mBuicéad",
  "item.minecraft.pufferfish_spawn_egg": "Ubh Ghiniúna Iasc Bolgach",
  "item.minecraft.pumpkin_pie": "Pióg Phuimcín",
  "item.minecraft.pumpkin_seeds": "Síolta Puimcín",
  "item.minecraft.purple_bundle": "Mála Corcra",
  "item.minecraft.purple_dye": "Ruaim Chorcra",
  "item.minecraft.purple_harness": "Úim Chorcra",
  "item.minecraft.quartz": "Grianchloch an Nether",
  "item.minecraft.rabbit": "Coinín Amh",
  "item.minecraft.rabbit_foot": "Cos Coinín",
  "item.minecraft.rabbit_hide": "Craiceann Coinín",
  "item.minecraft.rabbit_spawn_egg": "Ubh Ghiniúna Coiníní",
  "item.minecraft.rabbit_stew": "Stobhach Coinín",
  "item.minecraft.raiser_armor_trim_smithing_template": "Múnla Gaibhneachta",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Maisiú Cathéide de Bheanna",
  "item.minecraft.ravager_spawn_egg": "Ubh Ghiniúna Sladairí",
  "item.minecraft.raw_copper": "Copar Amh",
  "item.minecraft.raw_gold": "Ór Amh",
  "item.minecraft.raw_iron": "Amhiarann",
  "item.minecraft.recovery_compass": "Compás Aisghabhála",
  "item.minecraft.red_bundle": "Mála Dearg",
  "item.minecraft.red_dye": "Ruaim Dhearg",
  "item.minecraft.red_harness": "Úim Dhearg",
  "item.minecraft.redstone": "Deannach Redstone",
  "item.minecraft.resin_brick": "Bríce Roisín",
  "item.minecraft.resin_clump": "Meall Roisín",
  "item.minecraft.rib_armor_trim_smithing_template": "Múnla Gaibhneachta",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Maisiú Cathéide d'Easnacha",
  "item.minecraft.rotten_flesh": "Feoil Lofa",
  "item.minecraft.saddle": "Diallait",
  "item.minecraft.salmon": "Bradán Amh",
  "item.minecraft.salmon_bucket": "Bradán i mBuicéad",
  "item.minecraft.salmon_spawn_egg": "Ubh Ghiniúna Bradán",
  "item.minecraft.scrape_pottery_sherd": "Scealp Cré na Tua",
  "item.minecraft.scute": "Slige",
  "item.minecraft.sentry_armor_trim_smithing_template": "Múnla Gaibhneachta",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Maisiú Cathéide d'Fhairtheoir",
  "item.minecraft.shaper_armor_trim_smithing_template": "Múnla Gaibhneachta",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Maisiú Cathéide de Mhúnlóir",
  "item.minecraft.sheaf_pottery_shard": "Scealp Cré na Punainne",
  "item.minecraft.sheaf_pottery_sherd": "Scealp Cré na Punainne",
  "item.minecraft.shears": "Deimheas",
  "item.minecraft.sheep_spawn_egg": "Ubh Ghiniúna Caorach",
  "item.minecraft.shelter_pottery_shard": "Scealp Cré an Fhoscaidh",
  "item.minecraft.shelter_pottery_sherd": "Scealp Cré an Fhoscaidh",
  "item.minecraft.shield": "Sciath",
  "item.minecraft.shield.black": "Sciath Dhubh",
  "item.minecraft.shield.blue": "Sciath Ghorm",
  "item.minecraft.shield.brown": "Sciath Dhonn",
  "item.minecraft.shield.cyan": "Sciath Chian",
  "item.minecraft.shield.gray": "Sciath Liath",
  "item.minecraft.shield.green": "Sciath Uaine",
  "item.minecraft.shield.light_blue": "Sciath Bhánghorm",
  "item.minecraft.shield.light_gray": "Sciath Fhionnliath",
  "item.minecraft.shield.lime": "Sciath Ghlasuaine",
  "item.minecraft.shield.magenta": "Sciath Mhaigeanta",
  "item.minecraft.shield.orange": "Sciath Oráiste",
  "item.minecraft.shield.pink": "Sciath Bhándearg",
  "item.minecraft.shield.purple": "Sciath Chorcra",
  "item.minecraft.shield.red": "Sciath Dhearg",
  "item.minecraft.shield.white": "Sciath Bhán",
  "item.minecraft.shield.yellow": "Sciath Bhuí",
  "item.minecraft.shulker_shell": "Sliogán Shulker",
  "item.minecraft.shulker_spawn_egg": "Ubh Ghiniúna Shulker",
  "item.minecraft.sign": "Comhartha",
  "item.minecraft.silence_armor_trim_smithing_template": "Múnla Gaibhneachta",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Maisiú Cathéide de Chiúnas",
  "item.minecraft.silverfish_spawn_egg": "Ubh Ghiniúna Gilíní",
  "item.minecraft.skeleton_horse_spawn_egg": "Ubh Ghiniúna Capall Cnámharlaigh",
  "item.minecraft.skeleton_spawn_egg": "Ubh Ghiniúna Cnámharlach",
  "item.minecraft.skull_banner_pattern": "Patrún Meirge",
  "item.minecraft.skull_banner_pattern.desc": "Fíor Cloiginn",
  "item.minecraft.skull_banner_pattern.new": "Patrún Meirge d'Fhíor Cloiginn",
  "item.minecraft.skull_pottery_shard": "Scealp Cré an Chloiginn",
  "item.minecraft.skull_pottery_sherd": "Scealp Cré an Chloiginn",
  "item.minecraft.slime_ball": "Cnapán Glae",
  "item.minecraft.slime_spawn_egg": "Ubh Ghiniúna Ramallóg",
  "item.minecraft.smithing_template": "Múnla Gaibhneachta",
  "item.minecraft.smithing_template.applies_to": "Baineann sé le:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Cuir tinne nó criostal leis",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Cathéide",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Cuir píosa cathéide leis",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Tinní ⁊ Criostail",
  "item.minecraft.smithing_template.ingredients": "Comhábhair:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Cuir Tinne Netheríte leis",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Trealamh Diamaint",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Cuir cathéide, arm nó uirlis diamaint leis",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Tinne Netheríte",
  "item.minecraft.smithing_template.upgrade": "Uasghrádú: ",
  "item.minecraft.sniffer_spawn_egg": "Ubh Ghiniúna Srónadóirí",
  "item.minecraft.snort_pottery_shard": "Scealp Cré an tSrónadóra",
  "item.minecraft.snort_pottery_sherd": "Scealp Cré an tSrónadóra",
  "item.minecraft.snout_armor_trim_smithing_template": "Múnla Gaibhneachta",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Maisiú Cathéide de Shoc",
  "item.minecraft.snow_golem_spawn_egg": "Ubh Ghiniúna Gólam Sneachta",
  "item.minecraft.snowball": "Meall Sneachta",
  "item.minecraft.spectral_arrow": "Saighead Shíofrúil",
  "item.minecraft.spider_eye": "Súil Damháin Alla",
  "item.minecraft.spider_spawn_egg": "Ubh Ghiniúna Damhán Alla",
  "item.minecraft.spire_armor_trim_smithing_template": "Múnla Gaibhneachta",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Maisiú Cathéide de Spuaic",
  "item.minecraft.splash_potion": "Posóid Theilgeach",
  "item.minecraft.splash_potion.effect.awkward": "Posóid Theilgeach Chiotach",
  "item.minecraft.splash_potion.effect.empty": "Posóid Theilgeach Dhochumtha",
  "item.minecraft.splash_potion.effect.fire_resistance": "Posóid Theilgeach na Tinedhíonachta",
  "item.minecraft.splash_potion.effect.harming": "Posóid Theilgeach an Dochair",
  "item.minecraft.splash_potion.effect.healing": "Posóid Theilgeach an Leighis",
  "item.minecraft.splash_potion.effect.infested": "Posóid Theilgeach an Fhínithe",
  "item.minecraft.splash_potion.effect.invisibility": "Posóid Theilgeach na Dofheictheachta",
  "item.minecraft.splash_potion.effect.leaping": "Posóid Theilgeach na Léime",
  "item.minecraft.splash_potion.effect.levitation": "Posóid Theilgeach na Foluana",
  "item.minecraft.splash_potion.effect.luck": "Posóid Theilgeach an Áidh",
  "item.minecraft.splash_potion.effect.mundane": "Posóid Theilgeach Leamh",
  "item.minecraft.splash_potion.effect.night_vision": "Posóid Theilgeach Radhairc Oíche",
  "item.minecraft.splash_potion.effect.oozing": "Posóid Theilgeach an Phúscáin",
  "item.minecraft.splash_potion.effect.poison": "Posóid Theilgeach na Nimhe",
  "item.minecraft.splash_potion.effect.regeneration": "Posóid Theilgeach na hAthghiniúna",
  "item.minecraft.splash_potion.effect.slow_falling": "Posóid Theilgeach na Mallthitime",
  "item.minecraft.splash_potion.effect.slowness": "Posóid Theilgeach na Moille",
  "item.minecraft.splash_potion.effect.strength": "Posóid Theilgeach an Nirt",
  "item.minecraft.splash_potion.effect.swiftness": "Posóid Theilgeach an Luais",
  "item.minecraft.splash_potion.effect.thick": "Posóid Theilgeach Thiubh",
  "item.minecraft.splash_potion.effect.turtle_master": "Posóid Theilgeach Mháistir na dTurtar",
  "item.minecraft.splash_potion.effect.water": "Buidéal Uisce Teilgeach",
  "item.minecraft.splash_potion.effect.water_breathing": "Posóid Theilgeach Análú in Uisce",
  "item.minecraft.splash_potion.effect.weakness": "Posóid Theilgeach na Laige",
  "item.minecraft.splash_potion.effect.weaving": "Posóid Theilgeach na Fíodóireachta",
  "item.minecraft.splash_potion.effect.wind_charged": "Posóid Theilgeach an Lánáin Ghaoithe",
  "item.minecraft.spruce_boat": "Bád Sprúis",
  "item.minecraft.spruce_chest_boat": "Bád Sprúis le Cófra",
  "item.minecraft.spyglass": "Fadradharcán",
  "item.minecraft.squid_spawn_egg": "Ubh Ghiniúna Scuideanna",
  "item.minecraft.stick": "Maide",
  "item.minecraft.stone_axe": "Tua Chloiche",
  "item.minecraft.stone_hoe": "Grafóg Chloiche",
  "item.minecraft.stone_pickaxe": "Piocóid Chloiche",
  "item.minecraft.stone_shovel": "Sluasaid Chloiche",
  "item.minecraft.stone_spear": "Sleá Chloiche",
  "item.minecraft.stone_sword": "Claíomh Cloiche",
  "item.minecraft.stray_spawn_egg": "Ubh Ghiniúna Fánaithe",
  "item.minecraft.strider_spawn_egg": "Ubh Ghiniúna Truslógaithe",
  "item.minecraft.string": "Sreangán",
  "item.minecraft.sugar": "Siúcra",
  "item.minecraft.suspicious_stew": "Stobhach Amhrasach",
  "item.minecraft.sweet_berries": "Caora Milse",
  "item.minecraft.tadpole_bucket": "Torbán i mBuicéad",
  "item.minecraft.tadpole_spawn_egg": "Ubh Ghiniúna Torbán",
  "item.minecraft.tide_armor_trim_smithing_template": "Múnla Gaibhneachta",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Maisiú Cathéide de Thaoide",
  "item.minecraft.tipped_arrow": "Saighead Éifeachta",
  "item.minecraft.tipped_arrow.effect.awkward": "Saighead Éifeachta",
  "item.minecraft.tipped_arrow.effect.empty": "Saighead Éifeachta Dhochumtha",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Saighead na Tinedhíonachta",
  "item.minecraft.tipped_arrow.effect.harming": "Saighead an Dochair",
  "item.minecraft.tipped_arrow.effect.healing": "Saighead an Leighis",
  "item.minecraft.tipped_arrow.effect.infested": "Saighead an Fhínithe",
  "item.minecraft.tipped_arrow.effect.invisibility": "Saighead na Dofheictheachta",
  "item.minecraft.tipped_arrow.effect.leaping": "Saighead na Léime",
  "item.minecraft.tipped_arrow.effect.levitation": "Saighead na Foluana",
  "item.minecraft.tipped_arrow.effect.luck": "Saighead an Áidh",
  "item.minecraft.tipped_arrow.effect.mundane": "Saighead Éifeachta",
  "item.minecraft.tipped_arrow.effect.night_vision": "Saighead Radhairc Oíche",
  "item.minecraft.tipped_arrow.effect.oozing": "Saighead an Phúscáin",
  "item.minecraft.tipped_arrow.effect.poison": "Saighead na Nimhe",
  "item.minecraft.tipped_arrow.effect.regeneration": "Saighead na hAthghiniúna",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Saighead na Mallthitime",
  "item.minecraft.tipped_arrow.effect.slowness": "Saighead na Moille",
  "item.minecraft.tipped_arrow.effect.strength": "Saighead an Nirt",
  "item.minecraft.tipped_arrow.effect.swiftness": "Saighead an Luais",
  "item.minecraft.tipped_arrow.effect.thick": "Saighead Éifeachta",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Saighead Mháistir na dTurtar",
  "item.minecraft.tipped_arrow.effect.water": "Saighead Steallaidh",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Saighead Análú in Uisce",
  "item.minecraft.tipped_arrow.effect.weakness": "Saighead na Laige",
  "item.minecraft.tipped_arrow.effect.weaving": "Saighead na Fíodóireachta",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Saighead an Lánáin Gaoithe",
  "item.minecraft.tnt_minecart": "Cairt le TNT",
  "item.minecraft.torchflower_seeds": "Síolta Blátha Tóirse",
  "item.minecraft.totem_of_undying": "Tótam na Síoraíochta",
  "item.minecraft.trader_llama_spawn_egg": "Ubh Ghiniúna Lámaí Trádálaí",
  "item.minecraft.trial_key": "Eochair Thrialach",
  "item.minecraft.trident": "Trírinn",
  "item.minecraft.tropical_fish": "Iasc Trópaiceach",
  "item.minecraft.tropical_fish_bucket": "Iasc Trópaiceach i mBuicéad",
  "item.minecraft.tropical_fish_spawn_egg": "Ubh Ghiniúna Iasc Trópaiceach",
  "item.minecraft.turtle_helmet": "Blaosc Turtair",
  "item.minecraft.turtle_scute": "Slige Turtair",
  "item.minecraft.turtle_spawn_egg": "Ubh Ghiniúna Turtar",
  "item.minecraft.vex_armor_trim_smithing_template": "Múnla Gaibhneachta",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Maisiú Cathéide de Bhuairteoir",
  "item.minecraft.vex_spawn_egg": "Ubh Ghiniúna Buairteoirí",
  "item.minecraft.villager_spawn_egg": "Ubh Ghiniúna Sráideánach",
  "item.minecraft.vindicator_spawn_egg": "Ubh Ghiniúna Dlisteanóirí",
  "item.minecraft.wandering_trader_spawn_egg": "Ubh Ghiniúna Trádálaithe Fánacha",
  "item.minecraft.ward_armor_trim_smithing_template": "Múnla Gaibhneachta",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Maisiú Cathéide de Mhaor",
  "item.minecraft.warden_spawn_egg": "Ubh Ghiniúna Maor",
  "item.minecraft.warped_fungus_on_a_stick": "Fungas Saofa ar Maide",
  "item.minecraft.water_bucket": "Buicéad Uisce",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Múnla Gaibhneachta",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Maisiú Cathéide de Threoraí",
  "item.minecraft.wheat": "Cruithneacht",
  "item.minecraft.wheat_seeds": "Síolta Cruithneachta",
  "item.minecraft.white_bundle": "Mála Bán",
  "item.minecraft.white_dye": "Ruaim Bhán",
  "item.minecraft.white_harness": "Úim Bhán",
  "item.minecraft.wild_armor_trim_smithing_template": "Múnla Gaibhneachta",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Maisiú Cathéide de Dhufair",
  "item.minecraft.wind_charge": "Lánán Gaoithe",
  "item.minecraft.witch_spawn_egg": "Ubh Ghiniúna Cailleach",
  "item.minecraft.wither_skeleton_spawn_egg": "Ubh Ghiniúna Cnámharlach Wither",
  "item.minecraft.wither_spawn_egg": "Ubh Ghiniúna Wither",
  "item.minecraft.wolf_armor": "Cathéide Mic Tíre",
  "item.minecraft.wolf_spawn_egg": "Ubh Ghiniúna Mac Tíre",
  "item.minecraft.wooden_axe": "Tua Adhmaid",
  "item.minecraft.wooden_hoe": "Grafóg Adhmaid",
  "item.minecraft.wooden_pickaxe": "Piocóid Adhmaid",
  "item.minecraft.wooden_shovel": "Sluasaid Adhmaid",
  "item.minecraft.wooden_spear": "Sleá Adhmaid",
  "item.minecraft.wooden_sword": "Claíomh Adhmaid",
  "item.minecraft.writable_book": "Leabhar agus Peann Cleite",
  "item.minecraft.written_book": "Leabhar Scríofa",
  "item.minecraft.yellow_bundle": "Mála Buí",
  "item.minecraft.yellow_dye": "Ruaim Bhuí",
  "item.minecraft.yellow_harness": "Úim Bhuí",
  "item.minecraft.zoglin_spawn_egg": "Ubh Ghiniúna Zoglin",
  "item.minecraft.zombie_horse_spawn_egg": "Ubh Ghiniúna Capall Zombaí",
  "item.minecraft.zombie_nautilus_spawn_egg": "Ubh Ghiniúna Nátalas Zombaí",
  "item.minecraft.zombie_spawn_egg": "Ubh Ghiniúna Zombaithe",
  "item.minecraft.zombie_villager_spawn_egg": "Ubh Ghiniúna Sráideánach Zombaí",
  "item.minecraft.zombified_piglin_spawn_egg": "Ubh Ghiniúna Piglin Zombaí"
}
export const ga_ie = items; 
